import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _93f08a4c = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _da3f66e2 = () => interopDefault(import('../pages/aaModal.vue' /* webpackChunkName: "pages/aaModal" */))
const _19576972 = () => interopDefault(import('../pages/im.vue' /* webpackChunkName: "pages/im" */))
const _9058342a = () => interopDefault(import('../pages/Login.vue' /* webpackChunkName: "pages/Login" */))
const _c0fcd452 = () => interopDefault(import('../pages/not-permission.vue' /* webpackChunkName: "pages/not-permission" */))
const _6e1719cf = () => interopDefault(import('../pages/partnerLogin.vue' /* webpackChunkName: "pages/partnerLogin" */))
const _76ba22f4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0c0fe1dc = () => interopDefault(import('../pages/index/account.vue' /* webpackChunkName: "pages/index/account" */))
const _ae7cc874 = () => interopDefault(import('../pages/index/accountRecord/index.vue' /* webpackChunkName: "pages/index/accountRecord/index" */))
const _6f83d431 = () => interopDefault(import('../pages/index/approval/index.vue' /* webpackChunkName: "pages/index/approval/index" */))
const _1f043422 = () => interopDefault(import('../pages/index/certificateManagement/index.vue' /* webpackChunkName: "pages/index/certificateManagement/index" */))
const _91743792 = () => interopDefault(import('../pages/index/certificatePersonnel/index.vue' /* webpackChunkName: "pages/index/certificatePersonnel/index" */))
const _5de00bf8 = () => interopDefault(import('../pages/index/dictionary/index.vue' /* webpackChunkName: "pages/index/dictionary/index" */))
const _4248f9bb = () => interopDefault(import('../pages/index/educational/index.vue' /* webpackChunkName: "pages/index/educational/index" */))
const _3ca5b96d = () => interopDefault(import('../pages/index/enrolmentChannel/index.vue' /* webpackChunkName: "pages/index/enrolmentChannel/index" */))
const _b56fa21a = () => interopDefault(import('../pages/index/feedback/index.vue' /* webpackChunkName: "pages/index/feedback/index" */))
const _bd020396 = () => interopDefault(import('../pages/index/groupqrcode/index.vue' /* webpackChunkName: "pages/index/groupqrcode/index" */))
const _5851a134 = () => interopDefault(import('../pages/index/hmtservice/index.vue' /* webpackChunkName: "pages/index/hmtservice/index" */))
const _c233988c = () => interopDefault(import('../pages/index/index/index.vue' /* webpackChunkName: "pages/index/index/index" */))
const _bd95a2be = () => interopDefault(import('../pages/index/manageDeposit/index.vue' /* webpackChunkName: "pages/index/manageDeposit/index" */))
const _0132b771 = () => interopDefault(import('../pages/index/manageDepositReturn/index.vue' /* webpackChunkName: "pages/index/manageDepositReturn/index" */))
const _44f9faa6 = () => interopDefault(import('../pages/index/manageDepositX/index.vue' /* webpackChunkName: "pages/index/manageDepositX/index" */))
const _c9ae403e = () => interopDefault(import('../pages/index/manageMargin/index.vue' /* webpackChunkName: "pages/index/manageMargin/index" */))
const _3d270e9e = () => interopDefault(import('../pages/index/manageMarginReturn/index.vue' /* webpackChunkName: "pages/index/manageMarginReturn/index" */))
const _2205796d = () => interopDefault(import('../pages/index/manageMarginX/index.vue' /* webpackChunkName: "pages/index/manageMarginX/index" */))
const _0341edf8 = () => interopDefault(import('../pages/index/manageService/index.vue' /* webpackChunkName: "pages/index/manageService/index" */))
const _4dc44e37 = () => interopDefault(import('../pages/index/manualReconciliation/index.vue' /* webpackChunkName: "pages/index/manualReconciliation/index" */))
const _1d9a9746 = () => interopDefault(import('../pages/index/notice/index.vue' /* webpackChunkName: "pages/index/notice/index" */))
const _6a6bf9b9 = () => interopDefault(import('../pages/index/noticeOnline/index.vue' /* webpackChunkName: "pages/index/noticeOnline/index" */))
const _44089fe8 = () => interopDefault(import('../pages/index/policyForH5/index.vue' /* webpackChunkName: "pages/index/policyForH5/index" */))
const _080cb857 = () => interopDefault(import('../pages/index/product/index.vue' /* webpackChunkName: "pages/index/product/index" */))
const _84790f74 = () => interopDefault(import('../pages/index/reconcilation/index.vue' /* webpackChunkName: "pages/index/reconcilation/index" */))
const _702fe352 = () => interopDefault(import('../pages/index/schemeInspect/index.vue' /* webpackChunkName: "pages/index/schemeInspect/index" */))
const _12f6539e = () => interopDefault(import('../pages/index/selfService/index.vue' /* webpackChunkName: "pages/index/selfService/index" */))
const _3db0caa6 = () => interopDefault(import('../pages/index/workflow/index.vue' /* webpackChunkName: "pages/index/workflow/index" */))
const _f4245f76 = () => interopDefault(import('../pages/index/aiReporting/aiOrder/index.vue' /* webpackChunkName: "pages/index/aiReporting/aiOrder/index" */))
const _46cd35b4 = () => interopDefault(import('../pages/index/aiReporting/appletProduct/index.vue' /* webpackChunkName: "pages/index/aiReporting/appletProduct/index" */))
const _6c93cd21 = () => interopDefault(import('../pages/index/aiReporting/appletProductShare/index.vue' /* webpackChunkName: "pages/index/aiReporting/appletProductShare/index" */))
const _c86a9b5e = () => interopDefault(import('../pages/index/aiReporting/baseDataManager/index.vue' /* webpackChunkName: "pages/index/aiReporting/baseDataManager/index" */))
const _e174a5ae = () => interopDefault(import('../pages/index/aiReporting/creditCards/index.vue' /* webpackChunkName: "pages/index/aiReporting/creditCards/index" */))
const _6cf3907f = () => interopDefault(import('../pages/index/aiReporting/feedbackStatistics/index.vue' /* webpackChunkName: "pages/index/aiReporting/feedbackStatistics/index" */))
const _0024a222 = () => interopDefault(import('../pages/index/aiReporting/gptfeedback/index.vue' /* webpackChunkName: "pages/index/aiReporting/gptfeedback/index" */))
const _8fb49d04 = () => interopDefault(import('../pages/index/aiReporting/headQuarters/index.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/index" */))
const _20da3ca9 = () => interopDefault(import('../pages/index/aiReporting/policy/index.vue' /* webpackChunkName: "pages/index/aiReporting/policy/index" */))
const _b1b56f5e = () => interopDefault(import('../pages/index/aiReporting/policyInterpretation/index.vue' /* webpackChunkName: "pages/index/aiReporting/policyInterpretation/index" */))
const _4d494aaf = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/index.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/index" */))
const _46eced85 = () => interopDefault(import('../pages/index/aiReporting/timeAxis/index.vue' /* webpackChunkName: "pages/index/aiReporting/timeAxis/index" */))
const _1ca592e0 = () => interopDefault(import('../pages/index/artExamination/academic/index.vue' /* webpackChunkName: "pages/index/artExamination/academic/index" */))
const _02212259 = () => interopDefault(import('../pages/index/artExamination/checkAndUpload/index.vue' /* webpackChunkName: "pages/index/artExamination/checkAndUpload/index" */))
const _2fa13d08 = () => interopDefault(import('../pages/index/artExamination/onePointOneLevelArt/index.vue' /* webpackChunkName: "pages/index/artExamination/onePointOneLevelArt/index" */))
const _c8c1cf0a = () => interopDefault(import('../pages/index/artExamination/policy/index.vue' /* webpackChunkName: "pages/index/artExamination/policy/index" */))
const _2cd642fd = () => interopDefault(import('../pages/index/artExamination/specialtyScore/index.vue' /* webpackChunkName: "pages/index/artExamination/specialtyScore/index" */))
const _30eb53d7 = () => interopDefault(import('../pages/index/artExamination/university/index.vue' /* webpackChunkName: "pages/index/artExamination/university/index" */))
const _0005d51b = () => interopDefault(import('../pages/index/company/course/index.vue' /* webpackChunkName: "pages/index/company/course/index" */))
const _5c9b7b70 = () => interopDefault(import('../pages/index/company/courseclassif/index.vue' /* webpackChunkName: "pages/index/company/courseclassif/index" */))
const _77257ab9 = () => interopDefault(import('../pages/index/company/courselearning/index.vue' /* webpackChunkName: "pages/index/company/courselearning/index" */))
const _86a3f1f4 = () => interopDefault(import('../pages/index/company/CourseLearningProgress/index.vue' /* webpackChunkName: "pages/index/company/CourseLearningProgress/index" */))
const _380a6276 = () => interopDefault(import('../pages/index/company/feedback/index.vue' /* webpackChunkName: "pages/index/company/feedback/index" */))
const _d3d2de90 = () => interopDefault(import('../pages/index/company/studyNotes/index.vue' /* webpackChunkName: "pages/index/company/studyNotes/index" */))
const _434964bd = () => interopDefault(import('../pages/index/comprehensive/application/index.vue' /* webpackChunkName: "pages/index/comprehensive/application/index" */))
const _2669b9ea = () => interopDefault(import('../pages/index/comprehensive/coverLetter/index.vue' /* webpackChunkName: "pages/index/comprehensive/coverLetter/index" */))
const _2e0505e3 = () => interopDefault(import('../pages/index/comprehensive/matchIntroduce/index.vue' /* webpackChunkName: "pages/index/comprehensive/matchIntroduce/index" */))
const _13697622 = () => interopDefault(import('../pages/index/comprehensive/qualitySpecialityInfo/index.vue' /* webpackChunkName: "pages/index/comprehensive/qualitySpecialityInfo/index" */))
const _8a5fb848 = () => interopDefault(import('../pages/index/comprehensive/universityManage/index.vue' /* webpackChunkName: "pages/index/comprehensive/universityManage/index" */))
const _1261c80b = () => interopDefault(import('../pages/index/comprehensive/videoManagement/index.vue' /* webpackChunkName: "pages/index/comprehensive/videoManagement/index" */))
const _02978eee = () => interopDefault(import('../pages/index/customer/assignStudent/index.vue' /* webpackChunkName: "pages/index/customer/assignStudent/index" */))
const _ab1bcbd2 = () => interopDefault(import('../pages/index/customer/customer/index.vue' /* webpackChunkName: "pages/index/customer/customer/index" */))
const _4d1a9bc0 = () => interopDefault(import('../pages/index/customer/livingCustomer/index.vue' /* webpackChunkName: "pages/index/customer/livingCustomer/index" */))
const _f9c9c190 = () => interopDefault(import('../pages/index/customer/student/index.vue' /* webpackChunkName: "pages/index/customer/student/index" */))
const _6660aaa4 = () => interopDefault(import('../pages/index/customer/zonghe/index.vue' /* webpackChunkName: "pages/index/customer/zonghe/index" */))
const _24bcd402 = () => interopDefault(import('../pages/index/customerStatistics/customerInfo/index.vue' /* webpackChunkName: "pages/index/customerStatistics/customerInfo/index" */))
const _049c150e = () => interopDefault(import('../pages/index/customerStatistics/statistics/index.vue' /* webpackChunkName: "pages/index/customerStatistics/statistics/index" */))
const _980eb63e = () => interopDefault(import('../pages/index/dailyWeekly/weekly.vue' /* webpackChunkName: "pages/index/dailyWeekly/weekly" */))
const _df852b04 = () => interopDefault(import('../pages/index/dailyWork/dailySpeech/index.vue' /* webpackChunkName: "pages/index/dailyWork/dailySpeech/index" */))
const _54e80b4c = () => interopDefault(import('../pages/index/dailyWork/importWeek/index.vue' /* webpackChunkName: "pages/index/dailyWork/importWeek/index" */))
const _1ec6e7a1 = () => interopDefault(import('../pages/index/dailyWork/monthList/index.vue' /* webpackChunkName: "pages/index/dailyWork/monthList/index" */))
const _2e7c18f6 = () => interopDefault(import('../pages/index/dailyWork/weekList/index.vue' /* webpackChunkName: "pages/index/dailyWork/weekList/index" */))
const _48306661 = () => interopDefault(import('../pages/index/dailyWork/weekTemplate/index.vue' /* webpackChunkName: "pages/index/dailyWork/weekTemplate/index" */))
const _609e280e = () => interopDefault(import('../pages/index/dailyWork/yearList/index.vue' /* webpackChunkName: "pages/index/dailyWork/yearList/index" */))
const _4f7bbfe8 = () => interopDefault(import('../pages/index/examination/analysis/index.vue' /* webpackChunkName: "pages/index/examination/analysis/index" */))
const _31560870 = () => interopDefault(import('../pages/index/examination/bank/index.vue' /* webpackChunkName: "pages/index/examination/bank/index" */))
const _7f10242a = () => interopDefault(import('../pages/index/examination/exam/index.vue' /* webpackChunkName: "pages/index/examination/exam/index" */))
const _0d92e101 = () => interopDefault(import('../pages/index/examination/myPlan/index.vue' /* webpackChunkName: "pages/index/examination/myPlan/index" */))
const _1372fe56 = () => interopDefault(import('../pages/index/examination/paper/index.vue' /* webpackChunkName: "pages/index/examination/paper/index" */))
const _48800716 = () => interopDefault(import('../pages/index/examination/plan/index.vue' /* webpackChunkName: "pages/index/examination/plan/index" */))
const _f397ffae = () => interopDefault(import('../pages/index/examination/result/index.vue' /* webpackChunkName: "pages/index/examination/result/index" */))
const _4d88c9f9 = () => interopDefault(import('../pages/index/feedback/edit.vue' /* webpackChunkName: "pages/index/feedback/edit" */))
const _88df65ea = () => interopDefault(import('../pages/index/feedback/reply.vue' /* webpackChunkName: "pages/index/feedback/reply" */))
const _5d210548 = () => interopDefault(import('../pages/index/generalService/baseDataManagement/index.vue' /* webpackChunkName: "pages/index/generalService/baseDataManagement/index" */))
const _9f191662 = () => interopDefault(import('../pages/index/generalService/cityImports/index.vue' /* webpackChunkName: "pages/index/generalService/cityImports/index" */))
const _2d82617b = () => interopDefault(import('../pages/index/generalService/disciplineCategoryManagement/index.vue' /* webpackChunkName: "pages/index/generalService/disciplineCategoryManagement/index" */))
const _759cafbb = () => interopDefault(import('../pages/index/generalService/hotSpot/index.vue' /* webpackChunkName: "pages/index/generalService/hotSpot/index" */))
const _57ae451c = () => interopDefault(import('../pages/index/generalService/onePointOneLevel/index.vue' /* webpackChunkName: "pages/index/generalService/onePointOneLevel/index" */))
const _80c2982a = () => interopDefault(import('../pages/index/generalService/referenceScoreCalculate/index.vue' /* webpackChunkName: "pages/index/generalService/referenceScoreCalculate/index" */))
const _030a2379 = () => interopDefault(import('../pages/index/generalService/relativeManagement/index.vue' /* webpackChunkName: "pages/index/generalService/relativeManagement/index" */))
const _48c887ae = () => interopDefault(import('../pages/index/generalService/subjectAssessDataManagement/index.vue' /* webpackChunkName: "pages/index/generalService/subjectAssessDataManagement/index" */))
const _1e3083fc = () => interopDefault(import('../pages/index/generalService/supplementaryBaseScore/index.vue' /* webpackChunkName: "pages/index/generalService/supplementaryBaseScore/index" */))
const _618994d6 = () => interopDefault(import('../pages/index/generalService/trainingRecord/index.vue' /* webpackChunkName: "pages/index/generalService/trainingRecord/index" */))
const _09acbbfe = () => interopDefault(import('../pages/index/generalService/urbanCompetitiveness/index.vue' /* webpackChunkName: "pages/index/generalService/urbanCompetitiveness/index" */))
const _39e4d7c7 = () => interopDefault(import('../pages/index/generalService/versionManagement/index.vue' /* webpackChunkName: "pages/index/generalService/versionManagement/index" */))
const _027f26bc = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index" */))
const _1a3aa45a = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index/academyIntroduction.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index/academyIntroduction" */))
const _7d824672 = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index/academyIntroduction_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index/academyIntroduction_unreleased" */))
const _68b8022e = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index/oralLanguage.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index/oralLanguage" */))
const _dcc5c71e = () => interopDefault(import('../pages/index/hmtservice/index_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/index_unreleased" */))
const _6d75e833 = () => interopDefault(import('../pages/index/hmtservice/scheme.vue' /* webpackChunkName: "pages/index/hmtservice/scheme" */))
const _49b65fdc = () => interopDefault(import('../pages/index/hmtservice/scheme_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/scheme_unreleased" */))
const _0dad4e40 = () => interopDefault(import('../pages/index/information/ArtScore/index.vue' /* webpackChunkName: "pages/index/information/ArtScore/index" */))
const _78214dbf = () => interopDefault(import('../pages/index/information/batch/index.vue' /* webpackChunkName: "pages/index/information/batch/index" */))
const _34f710e7 = () => interopDefault(import('../pages/index/information/hmkColleges/index.vue' /* webpackChunkName: "pages/index/information/hmkColleges/index" */))
const _41ed83c2 = () => interopDefault(import('../pages/index/information/newsList/index.vue' /* webpackChunkName: "pages/index/information/newsList/index" */))
const _5726bc99 = () => interopDefault(import('../pages/index/information/onePointOneLevel/index.vue' /* webpackChunkName: "pages/index/information/onePointOneLevel/index" */))
const _042d1ef7 = () => interopDefault(import('../pages/index/information/Score/index.vue' /* webpackChunkName: "pages/index/information/Score/index" */))
const _59650486 = () => interopDefault(import('../pages/index/information/speciality/index.vue' /* webpackChunkName: "pages/index/information/speciality/index" */))
const _44dfda06 = () => interopDefault(import('../pages/index/information/specialityinfoElective/index.vue' /* webpackChunkName: "pages/index/information/specialityinfoElective/index" */))
const _a27c2484 = () => interopDefault(import('../pages/index/information/studentList/index.vue' /* webpackChunkName: "pages/index/information/studentList/index" */))
const _6e788f93 = () => interopDefault(import('../pages/index/information/subjectAssessment/index.vue' /* webpackChunkName: "pages/index/information/subjectAssessment/index" */))
const _42a3a515 = () => interopDefault(import('../pages/index/information/taiwanColleges/index.vue' /* webpackChunkName: "pages/index/information/taiwanColleges/index" */))
const _3a920a7f = () => interopDefault(import('../pages/index/information/university/index.vue' /* webpackChunkName: "pages/index/information/university/index" */))
const _4fe70103 = () => interopDefault(import('../pages/index/IPADManage/agentProduce/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentProduce/index" */))
const _45fb8688 = () => interopDefault(import('../pages/index/IPADManage/campus-banner/index.vue' /* webpackChunkName: "pages/index/IPADManage/campus-banner/index" */))
const _370be2b4 = () => interopDefault(import('../pages/index/IPADManage/campus-information/index.vue' /* webpackChunkName: "pages/index/IPADManage/campus-information/index" */))
const _3355029e = () => interopDefault(import('../pages/index/IPADManage/caseClassification/index.vue' /* webpackChunkName: "pages/index/IPADManage/caseClassification/index" */))
const _25c40139 = () => interopDefault(import('../pages/index/IPADManage/classicCases/index.vue' /* webpackChunkName: "pages/index/IPADManage/classicCases/index" */))
const _90d67144 = () => interopDefault(import('../pages/index/IPADManage/corporateCulture-banner/index.vue' /* webpackChunkName: "pages/index/IPADManage/corporateCulture-banner/index" */))
const _7dab5fca = () => interopDefault(import('../pages/index/IPADManage/corporateCulture-Images/index.vue' /* webpackChunkName: "pages/index/IPADManage/corporateCulture-Images/index" */))
const _19e5d168 = () => interopDefault(import('../pages/index/IPADManage/IndexConfiguration/index.vue' /* webpackChunkName: "pages/index/IPADManage/IndexConfiguration/index" */))
const _207a0b64 = () => interopDefault(import('../pages/index/IPADManage/produce/index.vue' /* webpackChunkName: "pages/index/IPADManage/produce/index" */))
const _a867f6b6 = () => interopDefault(import('../pages/index/lecturerApplication/application/index.vue' /* webpackChunkName: "pages/index/lecturerApplication/application/index" */))
const _2986450e = () => interopDefault(import('../pages/index/lecturerApplication/applicationReport/index.vue' /* webpackChunkName: "pages/index/lecturerApplication/applicationReport/index" */))
const _794e0871 = () => interopDefault(import('../pages/index/log/loginLog.vue' /* webpackChunkName: "pages/index/log/loginLog" */))
const _23ffa4a0 = () => interopDefault(import('../pages/index/log/operLog.vue' /* webpackChunkName: "pages/index/log/operLog" */))
const _e05ffb94 = () => interopDefault(import('../pages/index/manageDepositX/orderListModal.vue' /* webpackChunkName: "pages/index/manageDepositX/orderListModal" */))
const _4ec72376 = () => interopDefault(import('../pages/index/manageMarginX/orderListModal.vue' /* webpackChunkName: "pages/index/manageMarginX/orderListModal" */))
const _d2396e20 = () => interopDefault(import('../pages/index/monthly/monthly.vue' /* webpackChunkName: "pages/index/monthly/monthly" */))
const _47862dd5 = () => interopDefault(import('../pages/index/myToolBox/answers/index.vue' /* webpackChunkName: "pages/index/myToolBox/answers/index" */))
const _f221f340 = () => interopDefault(import('../pages/index/myToolBox/carryForward/index.vue' /* webpackChunkName: "pages/index/myToolBox/carryForward/index" */))
const _7368d270 = () => interopDefault(import('../pages/index/myToolBox/informationPackage/index.vue' /* webpackChunkName: "pages/index/myToolBox/informationPackage/index" */))
const _526f01e0 = () => interopDefault(import('../pages/index/myToolBox/libraryManage/index.vue' /* webpackChunkName: "pages/index/myToolBox/libraryManage/index" */))
const _4b27a3eb = () => interopDefault(import('../pages/index/myToolBox/mailList/index.vue' /* webpackChunkName: "pages/index/myToolBox/mailList/index" */))
const _23e3ef30 = () => interopDefault(import('../pages/index/myToolBox/mailListManage/index.vue' /* webpackChunkName: "pages/index/myToolBox/mailListManage/index" */))
const _668a71cf = () => interopDefault(import('../pages/index/myToolBox/product/index.vue' /* webpackChunkName: "pages/index/myToolBox/product/index" */))
const _74b9179b = () => interopDefault(import('../pages/index/myToolBox/video/index.vue' /* webpackChunkName: "pages/index/myToolBox/video/index" */))
const _98af89a2 = () => interopDefault(import('../pages/index/opportunityPoint/opportunity/index.vue' /* webpackChunkName: "pages/index/opportunityPoint/opportunity/index" */))
const _2796da9c = () => interopDefault(import('../pages/index/order/failOrders/index.vue' /* webpackChunkName: "pages/index/order/failOrders/index" */))
const _3b1a4ae7 = () => interopDefault(import('../pages/index/order/onlineOrders/index.vue' /* webpackChunkName: "pages/index/order/onlineOrders/index" */))
const _236a6bba = () => interopDefault(import('../pages/index/order/onlineRefund/index.vue' /* webpackChunkName: "pages/index/order/onlineRefund/index" */))
const _d9e0018a = () => interopDefault(import('../pages/index/order/pos/index.vue' /* webpackChunkName: "pages/index/order/pos/index" */))
const _32a9a1a6 = () => interopDefault(import('../pages/index/order/productChange/index.vue' /* webpackChunkName: "pages/index/order/productChange/index" */))
const _3a16e372 = () => interopDefault(import('../pages/index/order/refund/index.vue' /* webpackChunkName: "pages/index/order/refund/index" */))
const _57590cf3 = () => interopDefault(import('../pages/index/order/sales/index.vue' /* webpackChunkName: "pages/index/order/sales/index" */))
const _34fa6ede = () => interopDefault(import('../pages/index/order/touristOrders/index.vue' /* webpackChunkName: "pages/index/order/touristOrders/index" */))
const _4d5eb224 = () => interopDefault(import('../pages/index/padManage/campus/index.vue' /* webpackChunkName: "pages/index/padManage/campus/index" */))
const _086a1cb0 = () => interopDefault(import('../pages/index/padManage/group/index.vue' /* webpackChunkName: "pages/index/padManage/group/index" */))
const _045c344d = () => interopDefault(import('../pages/index/padManage/inventory/index.vue' /* webpackChunkName: "pages/index/padManage/inventory/index" */))
const _1b8e8e2b = () => interopDefault(import('../pages/index/product/offline/index.vue' /* webpackChunkName: "pages/index/product/offline/index" */))
const _73d9aa44 = () => interopDefault(import('../pages/index/product/stock/index.vue' /* webpackChunkName: "pages/index/product/stock/index" */))
const _56db8907 = () => interopDefault(import('../pages/index/quickReferenceTable/add.vue' /* webpackChunkName: "pages/index/quickReferenceTable/add" */))
const _997ad114 = () => interopDefault(import('../pages/index/quickReferenceTable/quickReferenceTable.vue' /* webpackChunkName: "pages/index/quickReferenceTable/quickReferenceTable" */))
const _08640f02 = () => interopDefault(import('../pages/index/report/achievement.vue' /* webpackChunkName: "pages/index/report/achievement" */))
const _03f69838 = () => interopDefault(import('../pages/index/report/campusPerformanceSummary/index.vue' /* webpackChunkName: "pages/index/report/campusPerformanceSummary/index" */))
const _16e11915 = () => interopDefault(import('../pages/index/report/customerStatisticsReport.vue' /* webpackChunkName: "pages/index/report/customerStatisticsReport" */))
const _47001a78 = () => interopDefault(import('../pages/index/report/education.vue' /* webpackChunkName: "pages/index/report/education" */))
const _6d910ad2 = () => interopDefault(import('../pages/index/report/expendReport.vue' /* webpackChunkName: "pages/index/report/expendReport" */))
const _c5ff6df2 = () => interopDefault(import('../pages/index/report/headquarters.vue' /* webpackChunkName: "pages/index/report/headquarters" */))
const _808b7208 = () => interopDefault(import('../pages/index/report/intenReport.vue' /* webpackChunkName: "pages/index/report/intenReport" */))
const _e39802f2 = () => interopDefault(import('../pages/index/report/lecturerPerformanceRankingTable/index.vue' /* webpackChunkName: "pages/index/report/lecturerPerformanceRankingTable/index" */))
const _6ae6edb9 = () => interopDefault(import('../pages/index/report/operationalPerformanceRankingTable/index.vue' /* webpackChunkName: "pages/index/report/operationalPerformanceRankingTable/index" */))
const _2b6d7186 = () => interopDefault(import('../pages/index/report/operationsManagerPerformanceReport/index.vue' /* webpackChunkName: "pages/index/report/operationsManagerPerformanceReport/index" */))
const _756315e1 = () => interopDefault(import('../pages/index/report/orderListModal.vue' /* webpackChunkName: "pages/index/report/orderListModal" */))
const _217a91d7 = () => interopDefault(import('../pages/index/report/performanceReport/index.vue' /* webpackChunkName: "pages/index/report/performanceReport/index" */))
const _4406debe = () => interopDefault(import('../pages/index/report/performanceReportJoin/index.vue' /* webpackChunkName: "pages/index/report/performanceReportJoin/index" */))
const _7ed5b45e = () => interopDefault(import('../pages/index/report/productLineTransfer.vue' /* webpackChunkName: "pages/index/report/productLineTransfer" */))
const _0cdfe51f = () => interopDefault(import('../pages/index/report/proIntenReport.vue' /* webpackChunkName: "pages/index/report/proIntenReport" */))
const _2fc549ae = () => interopDefault(import('../pages/index/report/salesSummaryB2C.vue' /* webpackChunkName: "pages/index/report/salesSummaryB2C" */))
const _c69125fc = () => interopDefault(import('../pages/index/report/serviceNumberReport.vue' /* webpackChunkName: "pages/index/report/serviceNumberReport" */))
const _166b77a6 = () => interopDefault(import('../pages/index/report/serviceProgressReport.vue' /* webpackChunkName: "pages/index/report/serviceProgressReport" */))
const _494b0a99 = () => interopDefault(import('../pages/index/report/serviceReport.vue' /* webpackChunkName: "pages/index/report/serviceReport" */))
const _754cb005 = () => interopDefault(import('../pages/index/report/serviceStepReport.vue' /* webpackChunkName: "pages/index/report/serviceStepReport" */))
const _caa2373e = () => interopDefault(import('../pages/index/report/teacherAchievementReport.vue' /* webpackChunkName: "pages/index/report/teacherAchievementReport" */))
const _a45a1570 = () => interopDefault(import('../pages/index/report/variousRegionsReport.vue' /* webpackChunkName: "pages/index/report/variousRegionsReport" */))
const _37e11926 = () => interopDefault(import('../pages/index/revenues/paymentRecord/index.vue' /* webpackChunkName: "pages/index/revenues/paymentRecord/index" */))
const _9ead416e = () => interopDefault(import('../pages/index/revenues/refundRecord/index.vue' /* webpackChunkName: "pages/index/revenues/refundRecord/index" */))
const _0beca47c = () => interopDefault(import('../pages/index/revenues/transferRecord/index.vue' /* webpackChunkName: "pages/index/revenues/transferRecord/index" */))
const _33ed375a = () => interopDefault(import('../pages/index/selfService/planStore/index.vue' /* webpackChunkName: "pages/index/selfService/planStore/index" */))
const _2843363e = () => interopDefault(import('../pages/index/selfService/programme/index.vue' /* webpackChunkName: "pages/index/selfService/programme/index" */))
const _84c6e6d2 = () => interopDefault(import('../pages/index/serviceSystem/career/index.vue' /* webpackChunkName: "pages/index/serviceSystem/career/index" */))
const _2bb65d46 = () => interopDefault(import('../pages/index/serviceSystem/entrancePlanningMap/index.vue' /* webpackChunkName: "pages/index/serviceSystem/entrancePlanningMap/index" */))
const _2946f056 = () => interopDefault(import('../pages/index/serviceSystem/evaluation/index.vue' /* webpackChunkName: "pages/index/serviceSystem/evaluation/index" */))
const _59fd1bd7 = () => interopDefault(import('../pages/index/serviceSystem/hrpReport/index.vue' /* webpackChunkName: "pages/index/serviceSystem/hrpReport/index" */))
const _08b06932 = () => interopDefault(import('../pages/index/serviceSystem/learnMethods/index.vue' /* webpackChunkName: "pages/index/serviceSystem/learnMethods/index" */))
const _631d9633 = () => interopDefault(import('../pages/index/serviceSystem/learnStatus/index.vue' /* webpackChunkName: "pages/index/serviceSystem/learnStatus/index" */))
const _01891fc4 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/index" */))
const _3793e82c = () => interopDefault(import('../pages/index/serviceSystem/partnerStudentList/index.vue' /* webpackChunkName: "pages/index/serviceSystem/partnerStudentList/index" */))
const _741e702c = () => interopDefault(import('../pages/index/serviceSystem/serviceConditions/index.vue' /* webpackChunkName: "pages/index/serviceSystem/serviceConditions/index" */))
const _41528e6c = () => interopDefault(import('../pages/index/serviceSystem/studentReport/index.vue' /* webpackChunkName: "pages/index/serviceSystem/studentReport/index" */))
const _9db8fc32 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/index.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/index" */))
const _57812cbd = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/index" */))
const _d8c6f3ce = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan-xk/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan-xk/index" */))
const _03abf0ab = () => interopDefault(import('../pages/index/stationNotification/myReceived/index.vue' /* webpackChunkName: "pages/index/stationNotification/myReceived/index" */))
const _696fd393 = () => interopDefault(import('../pages/index/stationNotification/myRelease/index.vue' /* webpackChunkName: "pages/index/stationNotification/myRelease/index" */))
const _348748d1 = () => interopDefault(import('../pages/index/stationNotification/taskSituation/index.vue' /* webpackChunkName: "pages/index/stationNotification/taskSituation/index" */))
const _7952c082 = () => interopDefault(import('../pages/index/system/configs/index.vue' /* webpackChunkName: "pages/index/system/configs/index" */))
const _ca151bb2 = () => interopDefault(import('../pages/index/system/menu/index.vue' /* webpackChunkName: "pages/index/system/menu/index" */))
const _4ad2a6f2 = () => interopDefault(import('../pages/index/system/org/index.vue' /* webpackChunkName: "pages/index/system/org/index" */))
const _108ba704 = () => interopDefault(import('../pages/index/system/role/index.vue' /* webpackChunkName: "pages/index/system/role/index" */))
const _3fe27140 = () => interopDefault(import('../pages/index/test/crud.vue' /* webpackChunkName: "pages/index/test/crud" */))
const _5a785818 = () => interopDefault(import('../pages/index/weekly/weekly.vue' /* webpackChunkName: "pages/index/weekly/weekly" */))
const _202e1f6b = () => interopDefault(import('../pages/index/workbench/approvalDealtService.vue' /* webpackChunkName: "pages/index/workbench/approvalDealtService" */))
const _191b9338 = () => interopDefault(import('../pages/index/workbench/eduDealtService.vue' /* webpackChunkName: "pages/index/workbench/eduDealtService" */))
const _39702e38 = () => interopDefault(import('../pages/index/workbench/finishedService.vue' /* webpackChunkName: "pages/index/workbench/finishedService" */))
const _45f840c8 = () => interopDefault(import('../pages/index/workbench/handleDone/index.vue' /* webpackChunkName: "pages/index/workbench/handleDone/index" */))
const _70c886b0 = () => interopDefault(import('../pages/index/workbench/myToDo/index.vue' /* webpackChunkName: "pages/index/workbench/myToDo/index" */))
const _660d8993 = () => interopDefault(import('../pages/index/workbench/notice.vue' /* webpackChunkName: "pages/index/workbench/notice" */))
const _35dde42c = () => interopDefault(import('../pages/index/workbench/noticeAdmin.vue' /* webpackChunkName: "pages/index/workbench/noticeAdmin" */))
const _e055e564 = () => interopDefault(import('../pages/index/workbench/salesDealtService.vue' /* webpackChunkName: "pages/index/workbench/salesDealtService" */))
const _4bf40db7 = () => interopDefault(import('../pages/index/workbench/serviceDealtService.vue' /* webpackChunkName: "pages/index/workbench/serviceDealtService" */))
const _3b813f68 = () => interopDefault(import('../pages/index/artExamination/university/orderListModal.vue' /* webpackChunkName: "pages/index/artExamination/university/orderListModal" */))
const _fd8db914 = () => interopDefault(import('../pages/index/artExamination/university/orderListModalEdit.vue' /* webpackChunkName: "pages/index/artExamination/university/orderListModalEdit" */))
const _3e43673f = () => interopDefault(import('../pages/index/customer/livingCustomer/customerListModal.vue' /* webpackChunkName: "pages/index/customer/livingCustomer/customerListModal" */))
const _7e2beda8 = () => interopDefault(import('../pages/index/customer/zonghe/honourPreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/honourPreviewModal" */))
const _ac7b4af0 = () => interopDefault(import('../pages/index/customer/zonghe/newPassPreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/newPassPreviewModal" */))
const _9b7c54e2 = () => interopDefault(import('../pages/index/customer/zonghe/oldPassPreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/oldPassPreviewModal" */))
const _21539084 = () => interopDefault(import('../pages/index/customer/zonghe/practicePreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/practicePreviewModal" */))
const _7a06c3cd = () => interopDefault(import('../pages/index/examination/analysis/viewInfo.vue' /* webpackChunkName: "pages/index/examination/analysis/viewInfo" */))
const _76f503b6 = () => interopDefault(import('../pages/index/generalService/hotSpot/hotSpotModal.vue' /* webpackChunkName: "pages/index/generalService/hotSpot/hotSpotModal" */))
const _0508a79c = () => interopDefault(import('../pages/index/hmtservice/application/addApplication.vue' /* webpackChunkName: "pages/index/hmtservice/application/addApplication" */))
const _4e80d173 = () => interopDefault(import('../pages/index/hmtservice/application/application.vue' /* webpackChunkName: "pages/index/hmtservice/application/application" */))
const _7093a1e8 = () => interopDefault(import('../pages/index/hmtservice/application/backMaterials.vue' /* webpackChunkName: "pages/index/hmtservice/application/backMaterials" */))
const _414e250f = () => interopDefault(import('../pages/index/hmtservice/application/materials.vue' /* webpackChunkName: "pages/index/hmtservice/application/materials" */))
const _71606295 = () => interopDefault(import('../pages/index/hmtservice/application/pushMaterials.vue' /* webpackChunkName: "pages/index/hmtservice/application/pushMaterials" */))
const _1a64cbcd = () => interopDefault(import('../pages/index/hmtservice/coverLetter/coverLetter.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/coverLetter" */))
const _be8d5810 = () => interopDefault(import('../pages/index/hmtservice/coverLetter/guidance.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/guidance" */))
const _ddf17f7e = () => interopDefault(import('../pages/index/hmtservice/coverLetter/upLoad.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/upLoad" */))
const _cccec29a = () => interopDefault(import('../pages/index/hmtservice/coverLetter/upSignup.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/upSignup" */))
const _1ec81dfd = () => interopDefault(import('../pages/index/hmtservice/coverLetter/upSignUpNew.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/upSignUpNew" */))
const _1a9a51e9 = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index_unreleased" */))
const _022f6011 = () => interopDefault(import('../pages/index/hmtservice/interviwe/addAdmissionModel.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/addAdmissionModel" */))
const _4170ad1c = () => interopDefault(import('../pages/index/hmtservice/interviwe/addTrainModel.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/addTrainModel" */))
const _4b353479 = () => interopDefault(import('../pages/index/hmtservice/interviwe/admission.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/admission" */))
const _045ceacb = () => interopDefault(import('../pages/index/hmtservice/interviwe/admissionStatus.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/admissionStatus" */))
const _5d86549f = () => interopDefault(import('../pages/index/hmtservice/interviwe/materials/index.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/materials/index" */))
const _b5bf4c06 = () => interopDefault(import('../pages/index/hmtservice/interviwe/trainManage.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/trainManage" */))
const _44c6347e = () => interopDefault(import('../pages/index/hmtservice/interviwe/trainPlan.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/trainPlan" */))
const _478f3e2e = () => interopDefault(import('../pages/index/hmtservice/interviwe/video/index.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/video/index" */))
const _9ae269e6 = () => interopDefault(import('../pages/index/hmtservice/plan/HM.vue' /* webpackChunkName: "pages/index/hmtservice/plan/HM" */))
const _613550fc = () => interopDefault(import('../pages/index/hmtservice/plan/T.vue' /* webpackChunkName: "pages/index/hmtservice/plan/T" */))
const _4ca9d1e3 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCardManage/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCardManage/index" */))
const _138192ac = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/index" */))
const _3be90998 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentInformation/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentInformation/index" */))
const _b2613628 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentList/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentList/index" */))
const _1b01ba52 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/index" */))
const _f9553714 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit2/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit2/index" */))
const _c7a972ea = () => interopDefault(import('../pages/index/IPADManage/agentManage/cardUsageRecord/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/cardUsageRecord/index" */))
const _73a31561 = () => interopDefault(import('../pages/index/IPADManage/agentManage/orgProductOffline/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/orgProductOffline/index" */))
const _043e42c6 = () => interopDefault(import('../pages/index/IPADManage/agentManage/productManage/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/productManage/index" */))
const _32fab90c = () => interopDefault(import('../pages/index/IPADManage/agentManage/revenueBreakdownQuery/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/revenueBreakdownQuery/index" */))
const _4ec6bb19 = () => interopDefault(import('../pages/index/IPADManage/agentManage/revenueQuery/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/revenueQuery/index" */))
const _3bc32936 = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/index" */))
const _76ebb45f = () => interopDefault(import('../pages/index/notice/components/orderNotification/index.vue' /* webpackChunkName: "pages/index/notice/components/orderNotification/index" */))
const _7ec98420 = () => interopDefault(import('../pages/index/noticeOnline/components/myReceived/index.vue' /* webpackChunkName: "pages/index/noticeOnline/components/myReceived/index" */))
const _3fc4b8d7 = () => interopDefault(import('../pages/index/noticeOnline/components/mySend/index.vue' /* webpackChunkName: "pages/index/noticeOnline/components/mySend/index" */))
const _73450e84 = () => interopDefault(import('../pages/index/opportunityPoint/opportunity/add.vue' /* webpackChunkName: "pages/index/opportunityPoint/opportunity/add" */))
const _27175e92 = () => interopDefault(import('../pages/index/product/offline/productListModal.vue' /* webpackChunkName: "pages/index/product/offline/productListModal" */))
const _7aac3dea = () => interopDefault(import('../pages/index/product/stock/addStockDrawer.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawer" */))
const _0b83a738 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForArt.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForArt" */))
const _6c516d27 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForHrp.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForHrp" */))
const _2ec63e16 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForSchoolPartner.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForSchoolPartner" */))
const _5a081ca5 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForZP.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForZP" */))
const _7d6a9a3f = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForZPSchoolPartner.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForZPSchoolPartner" */))
const _f608fdb6 = () => interopDefault(import('../pages/index/product/stock/orderListModal.vue' /* webpackChunkName: "pages/index/product/stock/orderListModal" */))
const _e403030a = () => interopDefault(import('../pages/index/product/stock/RefundStockDrawer.vue' /* webpackChunkName: "pages/index/product/stock/RefundStockDrawer" */))
const _64d653be = () => interopDefault(import('../pages/index/product/stock/selectProductModal.vue' /* webpackChunkName: "pages/index/product/stock/selectProductModal" */))
const _3ae0673a = () => interopDefault(import('../pages/index/product/stock/stockRefund.vue' /* webpackChunkName: "pages/index/product/stock/stockRefund" */))
const _3a7f8774 = () => interopDefault(import('../pages/index/reconcilation/components/table-expand.vue' /* webpackChunkName: "pages/index/reconcilation/components/table-expand" */))
const _38573b44 = () => interopDefault(import('../pages/index/report/evaluationReport/report1.vue' /* webpackChunkName: "pages/index/report/evaluationReport/report1" */))
const _383b0c42 = () => interopDefault(import('../pages/index/report/evaluationReport/report2.vue' /* webpackChunkName: "pages/index/report/evaluationReport/report2" */))
const _05224949 = () => interopDefault(import('../pages/index/schemeInspect/components/logo.vue' /* webpackChunkName: "pages/index/schemeInspect/components/logo" */))
const _fda47a92 = () => interopDefault(import('../pages/index/schemeInspect/components/pageLayout.vue' /* webpackChunkName: "pages/index/schemeInspect/components/pageLayout" */))
const _4a569c5b = () => interopDefault(import('../pages/index/schemeInspect/components/pageTitle.vue' /* webpackChunkName: "pages/index/schemeInspect/components/pageTitle" */))
const _6a8aae2a = () => interopDefault(import('../pages/index/schemeInspect/pages/1.vue' /* webpackChunkName: "pages/index/schemeInspect/pages/1" */))
const _6a6e7f28 = () => interopDefault(import('../pages/index/schemeInspect/pages/2.vue' /* webpackChunkName: "pages/index/schemeInspect/pages/2" */))
const _6a525026 = () => interopDefault(import('../pages/index/schemeInspect/pages/3.vue' /* webpackChunkName: "pages/index/schemeInspect/pages/3" */))
const _8ba286ec = () => interopDefault(import('../pages/index/selfService/components/DesignThoughtModal.vue' /* webpackChunkName: "pages/index/selfService/components/DesignThoughtModal" */))
const _abc9ed56 = () => interopDefault(import('../pages/index/selfService/components/LeaveMessageModal.vue' /* webpackChunkName: "pages/index/selfService/components/LeaveMessageModal" */))
const _2ac2e394 = () => interopDefault(import('../pages/index/selfService/components/seniority.vue' /* webpackChunkName: "pages/index/selfService/components/seniority" */))
const _88fd5c7e = () => interopDefault(import('../pages/index/selfService/components/studentInfo.vue' /* webpackChunkName: "pages/index/selfService/components/studentInfo" */))
const _b3b326a4 = () => interopDefault(import('../pages/index/selfService/stepFive/confirmationPlan.vue' /* webpackChunkName: "pages/index/selfService/stepFive/confirmationPlan" */))
const _7dd6d15c = () => interopDefault(import('../pages/index/selfService/stepFive/finalSolutionLibrary.vue' /* webpackChunkName: "pages/index/selfService/stepFive/finalSolutionLibrary" */))
const _75fbd482 = () => interopDefault(import('../pages/index/selfService/stepFive/universityBrochure.vue' /* webpackChunkName: "pages/index/selfService/stepFive/universityBrochure" */))
const _62f7cc2b = () => interopDefault(import('../pages/index/selfService/stepFour/addApplication.vue' /* webpackChunkName: "pages/index/selfService/stepFour/addApplication" */))
const _4213a10e = () => interopDefault(import('../pages/index/selfService/stepFour/backMaterials.vue' /* webpackChunkName: "pages/index/selfService/stepFour/backMaterials" */))
const _498aeb9e = () => interopDefault(import('../pages/index/selfService/stepFour/coverLetter.vue' /* webpackChunkName: "pages/index/selfService/stepFour/coverLetter" */))
const _1a2f371b = () => interopDefault(import('../pages/index/selfService/stepFour/guideVideo.vue' /* webpackChunkName: "pages/index/selfService/stepFour/guideVideo" */))
const _281fb9c0 = () => interopDefault(import('../pages/index/selfService/stepFour/materials.vue' /* webpackChunkName: "pages/index/selfService/stepFour/materials" */))
const _407a1fb4 = () => interopDefault(import('../pages/index/selfService/stepFour/pushMaterials.vue' /* webpackChunkName: "pages/index/selfService/stepFour/pushMaterials" */))
const _1ea0fe79 = () => interopDefault(import('../pages/index/selfService/stepSix/fillinVideo.vue' /* webpackChunkName: "pages/index/selfService/stepSix/fillinVideo" */))
const _302400d5 = () => interopDefault(import('../pages/index/selfService/stepSix/schemeScreenshot.vue' /* webpackChunkName: "pages/index/selfService/stepSix/schemeScreenshot" */))
const _56cd2cea = () => interopDefault(import('../pages/index/selfService/stepSix/upLoad.vue' /* webpackChunkName: "pages/index/selfService/stepSix/upLoad" */))
const _0df09186 = () => interopDefault(import('../pages/index/selfService/stepThree/planStore/index.vue' /* webpackChunkName: "pages/index/selfService/stepThree/planStore/index" */))
const _cdaa93be = () => interopDefault(import('../pages/index/selfService/stepThree/recruitment/index.vue' /* webpackChunkName: "pages/index/selfService/stepThree/recruitment/index" */))
const _3cf9d34e = () => interopDefault(import('../pages/index/selfService/stepThree/recruitStudent/index.vue' /* webpackChunkName: "pages/index/selfService/stepThree/recruitStudent/index" */))
const _eb6800c2 = () => interopDefault(import('../pages/index/selfService/stepTwo/guideVideo.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/guideVideo" */))
const _95726996 = () => interopDefault(import('../pages/index/selfService/stepTwo/match.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/match" */))
const _0ddfc9f2 = () => interopDefault(import('../pages/index/selfService/stepTwo/planDesign.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/planDesign" */))
const _8cfa0524 = () => interopDefault(import('../pages/index/selfService/stepTwo/seniority.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/seniority" */))
const _ffd6c928 = () => interopDefault(import('../pages/index/selfService/stepTwo/studentPassageway.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/studentPassageway" */))
const _1912e53c = () => interopDefault(import('../pages/index/selfService/stepTwo/videoDrawer.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/videoDrawer" */))
const _ab4e66ae = () => interopDefault(import('../pages/index/serviceSystem/commonFile/citySelect.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/citySelect" */))
const _73ca7aa2 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/complateServiceModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/complateServiceModal" */))
const _c0db8fee = () => interopDefault(import('../pages/index/serviceSystem/commonFile/designThought.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/designThought" */))
const _3bb23f31 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/designThoughtForOp.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/designThoughtForOp" */))
const _be14a814 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/designThoughtForSpecal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/designThoughtForSpecal" */))
const _0eb4042b = () => interopDefault(import('../pages/index/serviceSystem/commonFile/exportOption.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/exportOption" */))
const _630654b2 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/leaveMessage.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/leaveMessage" */))
const _a0e57f86 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/schemeInspect.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/schemeInspect" */))
const _04db223c = () => interopDefault(import('../pages/index/serviceSystem/commonFile/scoreStatisticsListModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/scoreStatisticsListModal" */))
const _910fa9a2 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/serviceStep.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/serviceStep" */))
const _1ff214bf = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityPackage.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityPackage" */))
const _c6f8fc82 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityPackageaAdd.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityPackageaAdd" */))
const _63cd7968 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityTreeModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityTreeModal" */))
const _7624c39b = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityTreeNew.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityTreeNew" */))
const _7f725ea6 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialRequirementsModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialRequirementsModal" */))
const _74e0c4d2 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentInfo" */))
const _86caae16 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentInfoDetailModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentInfoDetailModal" */))
const _0b297187 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentList.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentList" */))
const _03ba481c = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentUpdate.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentUpdate" */))
const _8af873a6 = () => interopDefault(import('../pages/index/serviceSystem/general-province/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/estimate-plan/index" */))
const _4db22ed7 = () => interopDefault(import('../pages/index/serviceSystem/general-province/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/final-plan/index" */))
const _1d9b4c49 = () => interopDefault(import('../pages/index/serviceSystem/general-province/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/initial-plan/index" */))
const _688ce9c8 = () => interopDefault(import('../pages/index/serviceSystem/general-province/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/scheme/index" */))
const _46b77a6f = () => interopDefault(import('../pages/index/serviceSystem/general-province/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/smart-report/index" */))
const _d8244cb2 = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/index" */))
const _52eb5d9d = () => interopDefault(import('../pages/index/serviceSystem/new-version/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/final-plan/index" */))
const _8d783ce2 = () => interopDefault(import('../pages/index/serviceSystem/new-version/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/initial-plan/index" */))
const _21b50ce2 = () => interopDefault(import('../pages/index/serviceSystem/new-version/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/scheme/index" */))
const _3b3fe096 = () => interopDefault(import('../pages/index/serviceSystem/new-version/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/smart-report/index" */))
const _d74378ba = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/estimate-plan.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/estimate-plan" */))
const _524cf57b = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/final-plan.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/final-plan" */))
const _7f86a2ad = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/initial-plan" */))
const _7c575500 = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/scheme.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/scheme" */))
const _26e0e56a = () => interopDefault(import('../pages/index/serviceSystem/occupations/occupation/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/occupation/index" */))
const _ba17fbc6 = () => interopDefault(import('../pages/index/serviceSystem/occupations/planning/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/planning/index" */))
const _a068f718 = () => interopDefault(import('../pages/index/serviceSystem/occupations/report/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/report/index" */))
const _c48968b6 = () => interopDefault(import('../pages/index/serviceSystem/occupations/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/scheme/index" */))
const _c8109b68 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/scheme/index" */))
const _d46ffcb8 = () => interopDefault(import('../pages/index/serviceSystem/partnerStudentList/addModal.vue' /* webpackChunkName: "pages/index/serviceSystem/partnerStudentList/addModal" */))
const _783a3a8e = () => interopDefault(import('../pages/index/serviceSystem/partnerStudentList/serviceStep.vue' /* webpackChunkName: "pages/index/serviceSystem/partnerStudentList/serviceStep" */))
const _ce542fd8 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/estimate-plan/index" */))
const _0552ae50 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/final-plan/index" */))
const _6f19d182 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/initial-plan/index" */))
const _2aeeaf15 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/scheme/index" */))
const _538b8b80 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/estimate-plan/index" */))
const _20d1a264 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/final-plan/index" */))
const _b2a7ded4 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/initial-plan/index" */))
const _1092cd29 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/scheme/index" */))
const _5e2d91a4 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/crm-slider/index.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/crm-slider/index" */))
const _72c76676 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/filter/index.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/filter/index" */))
const _b0d03afe = () => interopDefault(import('../pages/index/serviceSystem/volunteer/majorGroup.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/majorGroup" */))
const _a27a7f48 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/majorGroupPrint.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/majorGroupPrint" */))
const _2594eb74 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/majorGroupView.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/majorGroupView" */))
const _082bc5d8 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/majorNow.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/majorNow" */))
const _bacb4936 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/majorNowPrint.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/majorNowPrint" */))
const _4fe9ea1d = () => interopDefault(import('../pages/index/serviceSystem/volunteer/majorNowView.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/majorNowView" */))
const _6299ee42 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/modal.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/modal" */))
const _1732192e = () => interopDefault(import('../pages/index/serviceSystem/volunteer/qrCode.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/qrCode" */))
const _8248685e = () => interopDefault(import('../pages/index/serviceSystem/volunteer/selectSpecialityModal.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/selectSpecialityModal" */))
const _5caa519f = () => interopDefault(import('../pages/index/serviceSystem/volunteer/smartModal.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/smartModal" */))
const _105016b0 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/designThought.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/designThought" */))
const _24f48df2 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/designThoughtForOp.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/designThoughtForOp" */))
const _465b6728 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hm.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hm" */))
const _6935518c = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmDesignThoughtModal.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmDesignThoughtModal" */))
const _3f4e58a5 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmLeaveMessageModal.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmLeaveMessageModal" */))
const _8457b8a0 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmPreview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmPreview" */))
const _faa91b26 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmScheme.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmScheme" */))
const _f61af8e4 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/serviceStep.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/serviceStep" */))
const _2f708c4c = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/estimate-plan/index" */))
const _1bbd3518 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/final-plan/index" */))
const _d604736c = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/initial-plan/index" */))
const _96084c46 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/scheme/index" */))
const _83cc1720 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/smart-report/index" */))
const _130526cb = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/estimate-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/estimate-plan" */))
const _8b05b95a = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/final-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/final-plan" */))
const _c73a8af6 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/initial-plan" */))
const _16b82ed8 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/scheme.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/scheme" */))
const _35d77c28 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/index" */))
const _62b3b2bc = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/final-plan/index" */))
const _0f692a24 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/initial-plan/index" */))
const _79fac981 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/scheme/index" */))
const _21679914 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/smart-report/index" */))
const _07503b2c = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/occupation/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/occupation/index" */))
const _00bd12fc = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/planning/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/planning/index" */))
const _08114113 = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/report/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/report/index" */))
const _13fdef78 = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/scheme/index" */))
const _4a28081e = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan-xk/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan-xk/scheme/index" */))
const _571dd618 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/page.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/page" */))
const _3de154cd = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/scheme/index" */))
const _c1e7986c = () => interopDefault(import('../pages/index/serviceSystemArt/serviceConditions/1.vue' /* webpackChunkName: "pages/index/serviceSystemArt/serviceConditions/1" */))
const _11ef6ce6 = () => interopDefault(import('../pages/index/system/components/editDateDrawer.vue' /* webpackChunkName: "pages/index/system/components/editDateDrawer" */))
const _69f41f5f = () => interopDefault(import('../pages/index/system/org/index_backup.vue' /* webpackChunkName: "pages/index/system/org/index_backup" */))
const _36926c6e = () => interopDefault(import('../pages/index/aiReporting/appletProductShare/component/editDrawer.vue' /* webpackChunkName: "pages/index/aiReporting/appletProductShare/component/editDrawer" */))
const _6842b42b = () => interopDefault(import('../pages/index/aiReporting/creditCards/componts/editDialog.vue' /* webpackChunkName: "pages/index/aiReporting/creditCards/componts/editDialog" */))
const _121d0901 = () => interopDefault(import('../pages/index/aiReporting/feedbackStatistics/componts/editDialog.vue' /* webpackChunkName: "pages/index/aiReporting/feedbackStatistics/componts/editDialog" */))
const _23edb91e = () => interopDefault(import('../pages/index/aiReporting/gptfeedback/componts/editDialog.vue' /* webpackChunkName: "pages/index/aiReporting/gptfeedback/componts/editDialog" */))
const _dd504cde = () => interopDefault(import('../pages/index/aiReporting/headQuarters/components/addModal.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/components/addModal" */))
const _601177ce = () => interopDefault(import('../pages/index/aiReporting/headQuarters/components/codeLibrary.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/components/codeLibrary" */))
const _20e964d8 = () => interopDefault(import('../pages/index/aiReporting/headQuarters/components/vipCard.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/components/vipCard" */))
const _42bb0902 = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/components/addModal.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/components/addModal" */))
const _d575d9f0 = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/components/codeLibrary.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/components/codeLibrary" */))
const _40366506 = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/components/vipModal.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/components/vipModal" */))
const _1dbf82ea = () => interopDefault(import('../pages/index/aiReporting/timeAxis/components/timeDrawer.vue' /* webpackChunkName: "pages/index/aiReporting/timeAxis/components/timeDrawer" */))
const _489f194c = () => interopDefault(import('../pages/index/artExamination/academic/components/add.vue' /* webpackChunkName: "pages/index/artExamination/academic/components/add" */))
const _6b0620ce = () => interopDefault(import('../pages/index/artExamination/onePointOneLevelArt/components/edit.vue' /* webpackChunkName: "pages/index/artExamination/onePointOneLevelArt/components/edit" */))
const _c692ec62 = () => interopDefault(import('../pages/index/artExamination/policy/components/add.vue' /* webpackChunkName: "pages/index/artExamination/policy/components/add" */))
const _764757b0 = () => interopDefault(import('../pages/index/company/courselearning/components/editCategory.vue' /* webpackChunkName: "pages/index/company/courselearning/components/editCategory" */))
const _7d2c9b06 = () => interopDefault(import('../pages/index/company/CourseLearningProgress/components/table-expand.vue' /* webpackChunkName: "pages/index/company/CourseLearningProgress/components/table-expand" */))
const _865e3066 = () => interopDefault(import('../pages/index/comprehensive/application/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/application/components/add" */))
const _9dadd580 = () => interopDefault(import('../pages/index/comprehensive/coverLetter/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/coverLetter/components/add" */))
const _27813167 = () => interopDefault(import('../pages/index/comprehensive/matchIntroduce/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/matchIntroduce/components/add" */))
const _5779c04a = () => interopDefault(import('../pages/index/comprehensive/qualitySpecialityInfo/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/qualitySpecialityInfo/components/add" */))
const _875488e4 = () => interopDefault(import('../pages/index/comprehensive/universityManage/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/universityManage/components/add" */))
const _3dd85c3f = () => interopDefault(import('../pages/index/comprehensive/videoManagement/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/videoManagement/components/add" */))
const _0ed57108 = () => interopDefault(import('../pages/index/comprehensive/videoManagement/components/player.js' /* webpackChunkName: "pages/index/comprehensive/videoManagement/components/player" */))
const _5e2b5ed7 = () => interopDefault(import('../pages/index/comprehensive/videoManagement/components/videoList.vue' /* webpackChunkName: "pages/index/comprehensive/videoManagement/components/videoList" */))
const _35b97948 = () => interopDefault(import('../pages/index/generalService/disciplineCategoryManagement/components/updateDrawer.vue' /* webpackChunkName: "pages/index/generalService/disciplineCategoryManagement/components/updateDrawer" */))
const _f069f416 = () => interopDefault(import('../pages/index/hmtservice/interviwe/materials/addMaterial.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/materials/addMaterial" */))
const _4959d6a8 = () => interopDefault(import('../pages/index/hmtservice/interviwe/video/videoDrawer.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/video/videoDrawer" */))
const _231851e6 = () => interopDefault(import('../pages/index/information/newsList/components/newsDetail.vue' /* webpackChunkName: "pages/index/information/newsList/components/newsDetail" */))
const _2f31cee3 = () => interopDefault(import('../pages/index/information/newsList/components/push.vue' /* webpackChunkName: "pages/index/information/newsList/components/push" */))
const _ef3f11c4 = () => interopDefault(import('../pages/index/information/speciality/components/detail.vue' /* webpackChunkName: "pages/index/information/speciality/components/detail" */))
const _133baab2 = () => interopDefault(import('../pages/index/information/speciality/components/push.vue' /* webpackChunkName: "pages/index/information/speciality/components/push" */))
const _69f43a6c = () => interopDefault(import('../pages/index/myToolBox/answers/components/editClassify.vue' /* webpackChunkName: "pages/index/myToolBox/answers/components/editClassify" */))
const _398b4391 = () => interopDefault(import('../pages/index/myToolBox/answers/components/editDescribe.vue' /* webpackChunkName: "pages/index/myToolBox/answers/components/editDescribe" */))
const _ac732bbe = () => interopDefault(import('../pages/index/myToolBox/answers/components/feedback.vue' /* webpackChunkName: "pages/index/myToolBox/answers/components/feedback" */))
const _233200e2 = () => interopDefault(import('../pages/index/myToolBox/libraryManage/components/editCategory.vue' /* webpackChunkName: "pages/index/myToolBox/libraryManage/components/editCategory" */))
const _3b11008c = () => interopDefault(import('../pages/index/myToolBox/libraryManage/components/editLibrary.vue' /* webpackChunkName: "pages/index/myToolBox/libraryManage/components/editLibrary" */))
const _3f83b1e6 = () => interopDefault(import('../pages/index/notice/components/stationNotification/myReceived/index.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myReceived/index" */))
const _27276e1e = () => interopDefault(import('../pages/index/notice/components/stationNotification/myRelease/index.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myRelease/index" */))
const _4c7a98f8 = () => interopDefault(import('../pages/index/padManage/inventory/components/balance.vue' /* webpackChunkName: "pages/index/padManage/inventory/components/balance" */))
const _22399736 = () => interopDefault(import('../pages/index/padManage/inventory/components/detail.vue' /* webpackChunkName: "pages/index/padManage/inventory/components/detail" */))
const _165f7ebc = () => interopDefault(import('../pages/index/selfService/components/stepThree/recruitmentModel.vue' /* webpackChunkName: "pages/index/selfService/components/stepThree/recruitmentModel" */))
const _36bcc786 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/excellentList.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/excellentList" */))
const _f95f8bcc = () => interopDefault(import('../pages/index/selfService/components/stepTwo/excellentModel.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/excellentModel" */))
const _6fbbad85 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/passwayList.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/passwayList" */))
const _5b7851d2 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/passwayModel.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/passwayModel" */))
const _3f5cdef6 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/seniorityList.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/seniorityList" */))
const _217fd6aa = () => interopDefault(import('../pages/index/selfService/stepFive/components/DesignThoughtModal.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/DesignThoughtModal" */))
const _4544add8 = () => interopDefault(import('../pages/index/selfService/stepFive/components/LeaveMessageModal.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/LeaveMessageModal" */))
const _2a046574 = () => interopDefault(import('../pages/index/selfService/stepFive/components/recruitmentModel.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/recruitmentModel" */))
const _3e2a6cc0 = () => interopDefault(import('../pages/index/selfService/stepFive/components/studentInfo.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/studentInfo" */))
const _4de10958 = () => interopDefault(import('../pages/index/serviceSystem/evaluation/components/codeModal.vue' /* webpackChunkName: "pages/index/serviceSystem/evaluation/components/codeModal" */))
const _68c414f6 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/downloadPDF" */))
const _baaf43ea = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/downloadPDFNew.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/downloadPDFNew" */))
const _217578ec = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/leave-message" */))
const _56a3de8f = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/newPlan-by-lastStep" */))
const _ed5579fe = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/scheme-inspect" */))
const _78397778 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/studentInfo" */))
const _def10b86 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/visable-field-config" */))
const _a452d240 = () => interopDefault(import('../pages/index/serviceSystem/general-province/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/general-province/utils/utils" */))
const _cdf941ce = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/design-thought.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/design-thought" */))
const _52e2fc9c = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/leave-message" */))
const _30e8bad5 = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/newPlan-by-lastStep" */))
const _775d52fb = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/scheme-inspect" */))
const _f9d872ec = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/studentInfo" */))
const _0243b292 = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/visable-field-config" */))
const _b3985bb4 = () => interopDefault(import('../pages/index/serviceSystem/new-version/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/new-version/utils/utils" */))
const _23c6a98c = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/downloadPDF/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/downloadPDF/downloadPDF" */))
const _3342581c = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/components/leave-message" */))
const _817e5cf6 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/components/scheme-preview" */))
const _be83a118 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/components/studentInfo" */))
const _3e1a3f88 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/chooseSpeciality.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/chooseSpeciality" */))
const _6ae1cad0 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/fieldConfig.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/fieldConfig" */))
const _2f55e7b6 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/newPlanByLastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/newPlanByLastStep" */))
const _9c110c88 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/preview.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/preview" */))
const _49c66519 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/utils/utils" */))
const _fb79446c = () => interopDefault(import('../pages/index/serviceSystem/professionNew/components/newPlanByLastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/components/newPlanByLastStep" */))
const _2cec8e60 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/components/preview.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/components/preview" */))
const _477a0fa6 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/professionNew/utils/utils" */))
const _196397a2 = () => interopDefault(import('../pages/index/serviceSystem/serviceConditions/components/addConfig.vue' /* webpackChunkName: "pages/index/serviceSystem/serviceConditions/components/addConfig" */))
const _097e93ca = () => interopDefault(import('../pages/index/serviceSystem/volunteer/component/distributeMoal.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/component/distributeMoal" */))
const _79418706 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/downloadPDF" */))
const _170aa3a6 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/leave-message" */))
const _2aa25f10 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/newPlan-by-lastStep" */))
const _16f6b5e0 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/scheme-inspect" */))
const _7186d5c5 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/studentInfo" */))
const _3c5909dc = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/visable-field-config" */))
const _092fa1e1 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/utils/utils" */))
const _680e2312 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/components/SmartReport.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/components/SmartReport" */))
const _3900873c = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/downloadPDF/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/downloadPDF/downloadPDF" */))
const _7ca1464c = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/design-thought.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/design-thought" */))
const _4b7b47d1 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/leave-message" */))
const _82eba498 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/newPlan-by-lastStep" */))
const _bfed5e88 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/scheme-inspect" */))
const _76698869 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/studentInfo" */))
const _256b0fb8 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/visable-field-config" */))
const _73ae2a85 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/utils/utils" */))
const _59cf411d = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/components/leave-message" */))
const _6a5108a4 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/components/scheme-preview" */))
const _73c364b5 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/components/studentInfo" */))
const _50a1b37c = () => interopDefault(import('../pages/index/stationNotification/myReceived/components/edit.vue' /* webpackChunkName: "pages/index/stationNotification/myReceived/components/edit" */))
const _7d00054d = () => interopDefault(import('../pages/index/stationNotification/myReceived/components/readView.vue' /* webpackChunkName: "pages/index/stationNotification/myReceived/components/readView" */))
const _73b51464 = () => interopDefault(import('../pages/index/stationNotification/myRelease/components/edit.vue' /* webpackChunkName: "pages/index/stationNotification/myRelease/components/edit" */))
const _c86929d8 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCardManage/components/soldRecords.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCardManage/components/soldRecords" */))
const _54788fc2 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/customerDetail.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/customerDetail" */))
const _e51c642e = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/orderList.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/orderList" */))
const _a6940b68 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/province.js' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/province" */))
const _21d61db4 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/viewInfo.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/viewInfo" */))
const _7680ded0 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentList/components/hairpin.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentList/components/hairpin" */))
const _cf5f3b9c = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/card-list.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/card-list" */))
const _36e43c3e = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/dictConfig.js' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/dictConfig" */))
const _7c2fdc76 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/orderDetail.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/orderDetail" */))
const _1354a583 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/orderList.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/orderList" */))
const _75079bde = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit2/components/witchdraw.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit2/components/witchdraw" */))
const _dc941580 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit2/components/witchdrawOrder.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit2/components/witchdrawOrder" */))
const _7012b7c9 = () => interopDefault(import('../pages/index/IPADManage/agentManage/cardUsageRecord/components/editTime.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/cardUsageRecord/components/editTime" */))
const _7b21d0e8 = () => interopDefault(import('../pages/index/IPADManage/agentManage/revenueBreakdownQuery/components/table-expand.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/revenueBreakdownQuery/components/table-expand" */))
const _77e53a01 = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/components/cardView.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/components/cardView" */))
const _219ff832 = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/components/convertCard.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/components/convertCard" */))
const _3261542b = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/components/invalidCard.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/components/invalidCard" */))
const _4b8e22fe = () => interopDefault(import('../pages/index/noticeOnline/components/myReceived/components/edit.vue' /* webpackChunkName: "pages/index/noticeOnline/components/myReceived/components/edit" */))
const _dca196b0 = () => interopDefault(import('../pages/index/noticeOnline/components/mySend/components/edit.vue' /* webpackChunkName: "pages/index/noticeOnline/components/mySend/components/edit" */))
const _e85ddf0e = () => interopDefault(import('../pages/index/noticeOnline/components/mySend/components/readView.vue' /* webpackChunkName: "pages/index/noticeOnline/components/mySend/components/readView" */))
const _5b8b5620 = () => interopDefault(import('../pages/index/serviceSystem/general-province/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/estimate-plan/components/choose-of-profession" */))
const _25f88a14 = () => interopDefault(import('../pages/index/serviceSystem/general-province/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/estimate-plan/components/scheme-preview" */))
const _b2e845cc = () => interopDefault(import('../pages/index/serviceSystem/general-province/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/final-plan/components/choose-of-profession" */))
const _51140c84 = () => interopDefault(import('../pages/index/serviceSystem/general-province/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/final-plan/components/scheme-preview" */))
const _ab979fe8 = () => interopDefault(import('../pages/index/serviceSystem/general-province/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/initial-plan/components/choose-of-profession" */))
const _ee682ba0 = () => interopDefault(import('../pages/index/serviceSystem/general-province/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/initial-plan/components/scheme-preview" */))
const _7b5b5ab2 = () => interopDefault(import('../pages/index/serviceSystem/general-province/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/smart-report/components/choose-of-profession" */))
const _2b0f6cb3 = () => interopDefault(import('../pages/index/serviceSystem/general-province/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/smart-report/components/scheme-detail" */))
const _9ff6b82c = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/components/choose-of-profession" */))
const _5450cb68 = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/components/downloadPDF" */))
const _fcffc6e4 = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/components/scheme-preview" */))
const _0c3a8060 = () => interopDefault(import('../pages/index/serviceSystem/new-version/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/final-plan/components/choose-of-profession" */))
const _409a0984 = () => interopDefault(import('../pages/index/serviceSystem/new-version/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/final-plan/components/scheme-preview" */))
const _5ec719d2 = () => interopDefault(import('../pages/index/serviceSystem/new-version/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/initial-plan/components/choose-of-profession" */))
const _392b2076 = () => interopDefault(import('../pages/index/serviceSystem/new-version/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/initial-plan/components/scheme-preview" */))
const _2fee4478 = () => interopDefault(import('../pages/index/serviceSystem/new-version/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/smart-report/components/choose-of-profession" */))
const _332554a6 = () => interopDefault(import('../pages/index/serviceSystem/new-version/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/smart-report/components/scheme-detail" */))
const _5beca24f = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/estimate-plan/components/choose-of-profession" */))
const _7d67ea9a = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/estimate-plan/components/scheme-preview" */))
const _20d0a41b = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/final-plan/components/choose-of-profession" */))
const _0acf5502 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/final-plan/components/scheme-preview" */))
const _b3398a66 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/initial-plan/components/choose-of-profession" */))
const _6cc659b1 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/initial-plan/components/scheme-preview" */))
const _778a6573 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/smart-report/components/choose-of-profession" */))
const _6c388912 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/smart-report/components/scheme-detail" */))
const _7f21372b = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/components/choose-of-profession" */))
const _fcadac2a = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/components/downloadPDF" */))
const _3958748f = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/components/scheme-preview" */))
const _4d639cbf = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/final-plan/components/choose-of-profession" */))
const _2728cdba = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/final-plan/components/scheme-preview" */))
const _0bcacb1e = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/initial-plan/components/choose-of-profession" */))
const _36d74455 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/initial-plan/components/scheme-preview" */))
const _697c75d2 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/smart-report/components/choose-of-profession" */))
const _96648c24 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/smart-report/components/scheme-detail" */))
const _639f84d4 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/initial-plan" */))
const _14e732e2 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/scheme-preview" */))
const _669f24dc = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/initial-plan" */))
const _7f053673 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/PlanSelection.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/PlanSelection" */))
const _36c83d3d = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/RightDrawer.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/RightDrawer" */))
const _7d737e84 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-version/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-version/initial-plan" */))
const _5bf4d75e = () => interopDefault(import('../pages/index/notice/components/stationNotification/myReceived/components/edit.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myReceived/components/edit" */))
const _c546277c = () => interopDefault(import('../pages/index/notice/components/stationNotification/myRelease/components/edit.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myRelease/components/edit" */))
const _14456b13 = () => interopDefault(import('../pages/index/notice/components/stationNotification/myRelease/components/readView.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myRelease/components/readView" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _93f08a4c,
    name: "404"
  }, {
    path: "/aaModal",
    component: _da3f66e2,
    name: "aaModal"
  }, {
    path: "/im",
    component: _19576972,
    name: "im"
  }, {
    path: "/Login",
    component: _9058342a,
    name: "Login"
  }, {
    path: "/not-permission",
    component: _c0fcd452,
    name: "not-permission"
  }, {
    path: "/partnerLogin",
    component: _6e1719cf,
    name: "partnerLogin"
  }, {
    path: "/",
    component: _76ba22f4,
    name: "index",
    children: [{
      path: "account",
      component: _0c0fe1dc,
      name: "index-account"
    }, {
      path: "accountRecord",
      component: _ae7cc874,
      name: "index-accountRecord"
    }, {
      path: "approval",
      component: _6f83d431,
      name: "index-approval"
    }, {
      path: "certificateManagement",
      component: _1f043422,
      name: "index-certificateManagement"
    }, {
      path: "certificatePersonnel",
      component: _91743792,
      name: "index-certificatePersonnel"
    }, {
      path: "dictionary",
      component: _5de00bf8,
      name: "index-dictionary"
    }, {
      path: "educational",
      component: _4248f9bb,
      name: "index-educational"
    }, {
      path: "enrolmentChannel",
      component: _3ca5b96d,
      name: "index-enrolmentChannel"
    }, {
      path: "feedback",
      component: _b56fa21a,
      name: "index-feedback"
    }, {
      path: "groupqrcode",
      component: _bd020396,
      name: "index-groupqrcode"
    }, {
      path: "hmtservice",
      component: _5851a134,
      name: "index-hmtservice"
    }, {
      path: "index",
      component: _c233988c,
      name: "index-index"
    }, {
      path: "manageDeposit",
      component: _bd95a2be,
      name: "index-manageDeposit"
    }, {
      path: "manageDepositReturn",
      component: _0132b771,
      name: "index-manageDepositReturn"
    }, {
      path: "manageDepositX",
      component: _44f9faa6,
      name: "index-manageDepositX"
    }, {
      path: "manageMargin",
      component: _c9ae403e,
      name: "index-manageMargin"
    }, {
      path: "manageMarginReturn",
      component: _3d270e9e,
      name: "index-manageMarginReturn"
    }, {
      path: "manageMarginX",
      component: _2205796d,
      name: "index-manageMarginX"
    }, {
      path: "manageService",
      component: _0341edf8,
      name: "index-manageService"
    }, {
      path: "manualReconciliation",
      component: _4dc44e37,
      name: "index-manualReconciliation"
    }, {
      path: "notice",
      component: _1d9a9746,
      name: "index-notice"
    }, {
      path: "noticeOnline",
      component: _6a6bf9b9,
      name: "index-noticeOnline"
    }, {
      path: "policyForH5",
      component: _44089fe8,
      name: "index-policyForH5"
    }, {
      path: "product",
      component: _080cb857,
      name: "index-product"
    }, {
      path: "reconcilation",
      component: _84790f74,
      name: "index-reconcilation"
    }, {
      path: "schemeInspect",
      component: _702fe352,
      name: "index-schemeInspect"
    }, {
      path: "selfService",
      component: _12f6539e,
      name: "index-selfService"
    }, {
      path: "workflow",
      component: _3db0caa6,
      name: "index-workflow"
    }, {
      path: "aiReporting/aiOrder",
      component: _f4245f76,
      name: "index-aiReporting-aiOrder"
    }, {
      path: "aiReporting/appletProduct",
      component: _46cd35b4,
      name: "index-aiReporting-appletProduct"
    }, {
      path: "aiReporting/appletProductShare",
      component: _6c93cd21,
      name: "index-aiReporting-appletProductShare"
    }, {
      path: "aiReporting/baseDataManager",
      component: _c86a9b5e,
      name: "index-aiReporting-baseDataManager"
    }, {
      path: "aiReporting/creditCards",
      component: _e174a5ae,
      name: "index-aiReporting-creditCards"
    }, {
      path: "aiReporting/feedbackStatistics",
      component: _6cf3907f,
      name: "index-aiReporting-feedbackStatistics"
    }, {
      path: "aiReporting/gptfeedback",
      component: _0024a222,
      name: "index-aiReporting-gptfeedback"
    }, {
      path: "aiReporting/headQuarters",
      component: _8fb49d04,
      name: "index-aiReporting-headQuarters"
    }, {
      path: "aiReporting/policy",
      component: _20da3ca9,
      name: "index-aiReporting-policy"
    }, {
      path: "aiReporting/policyInterpretation",
      component: _b1b56f5e,
      name: "index-aiReporting-policyInterpretation"
    }, {
      path: "aiReporting/redemptionCode",
      component: _4d494aaf,
      name: "index-aiReporting-redemptionCode"
    }, {
      path: "aiReporting/timeAxis",
      component: _46eced85,
      name: "index-aiReporting-timeAxis"
    }, {
      path: "artExamination/academic",
      component: _1ca592e0,
      name: "index-artExamination-academic"
    }, {
      path: "artExamination/checkAndUpload",
      component: _02212259,
      name: "index-artExamination-checkAndUpload"
    }, {
      path: "artExamination/onePointOneLevelArt",
      component: _2fa13d08,
      name: "index-artExamination-onePointOneLevelArt"
    }, {
      path: "artExamination/policy",
      component: _c8c1cf0a,
      name: "index-artExamination-policy"
    }, {
      path: "artExamination/specialtyScore",
      component: _2cd642fd,
      name: "index-artExamination-specialtyScore"
    }, {
      path: "artExamination/university",
      component: _30eb53d7,
      name: "index-artExamination-university"
    }, {
      path: "company/course",
      component: _0005d51b,
      name: "index-company-course"
    }, {
      path: "company/courseclassif",
      component: _5c9b7b70,
      name: "index-company-courseclassif"
    }, {
      path: "company/courselearning",
      component: _77257ab9,
      name: "index-company-courselearning"
    }, {
      path: "company/CourseLearningProgress",
      component: _86a3f1f4,
      name: "index-company-CourseLearningProgress"
    }, {
      path: "company/feedback",
      component: _380a6276,
      name: "index-company-feedback"
    }, {
      path: "company/studyNotes",
      component: _d3d2de90,
      name: "index-company-studyNotes"
    }, {
      path: "comprehensive/application",
      component: _434964bd,
      name: "index-comprehensive-application"
    }, {
      path: "comprehensive/coverLetter",
      component: _2669b9ea,
      name: "index-comprehensive-coverLetter"
    }, {
      path: "comprehensive/matchIntroduce",
      component: _2e0505e3,
      name: "index-comprehensive-matchIntroduce"
    }, {
      path: "comprehensive/qualitySpecialityInfo",
      component: _13697622,
      name: "index-comprehensive-qualitySpecialityInfo"
    }, {
      path: "comprehensive/universityManage",
      component: _8a5fb848,
      name: "index-comprehensive-universityManage"
    }, {
      path: "comprehensive/videoManagement",
      component: _1261c80b,
      name: "index-comprehensive-videoManagement"
    }, {
      path: "customer/assignStudent",
      component: _02978eee,
      name: "index-customer-assignStudent"
    }, {
      path: "customer/customer",
      component: _ab1bcbd2,
      name: "index-customer-customer"
    }, {
      path: "customer/livingCustomer",
      component: _4d1a9bc0,
      name: "index-customer-livingCustomer"
    }, {
      path: "customer/student",
      component: _f9c9c190,
      name: "index-customer-student"
    }, {
      path: "customer/zonghe",
      component: _6660aaa4,
      name: "index-customer-zonghe"
    }, {
      path: "customerStatistics/customerInfo",
      component: _24bcd402,
      name: "index-customerStatistics-customerInfo"
    }, {
      path: "customerStatistics/statistics",
      component: _049c150e,
      name: "index-customerStatistics-statistics"
    }, {
      path: "dailyWeekly/weekly",
      component: _980eb63e,
      name: "index-dailyWeekly-weekly"
    }, {
      path: "dailyWork/dailySpeech",
      component: _df852b04,
      name: "index-dailyWork-dailySpeech"
    }, {
      path: "dailyWork/importWeek",
      component: _54e80b4c,
      name: "index-dailyWork-importWeek"
    }, {
      path: "dailyWork/monthList",
      component: _1ec6e7a1,
      name: "index-dailyWork-monthList"
    }, {
      path: "dailyWork/weekList",
      component: _2e7c18f6,
      name: "index-dailyWork-weekList"
    }, {
      path: "dailyWork/weekTemplate",
      component: _48306661,
      name: "index-dailyWork-weekTemplate"
    }, {
      path: "dailyWork/yearList",
      component: _609e280e,
      name: "index-dailyWork-yearList"
    }, {
      path: "examination/analysis",
      component: _4f7bbfe8,
      name: "index-examination-analysis"
    }, {
      path: "examination/bank",
      component: _31560870,
      name: "index-examination-bank"
    }, {
      path: "examination/exam",
      component: _7f10242a,
      name: "index-examination-exam"
    }, {
      path: "examination/myPlan",
      component: _0d92e101,
      name: "index-examination-myPlan"
    }, {
      path: "examination/paper",
      component: _1372fe56,
      name: "index-examination-paper"
    }, {
      path: "examination/plan",
      component: _48800716,
      name: "index-examination-plan"
    }, {
      path: "examination/result",
      component: _f397ffae,
      name: "index-examination-result"
    }, {
      path: "feedback/edit",
      component: _4d88c9f9,
      name: "index-feedback-edit"
    }, {
      path: "feedback/reply",
      component: _88df65ea,
      name: "index-feedback-reply"
    }, {
      path: "generalService/baseDataManagement",
      component: _5d210548,
      name: "index-generalService-baseDataManagement"
    }, {
      path: "generalService/cityImports",
      component: _9f191662,
      name: "index-generalService-cityImports"
    }, {
      path: "generalService/disciplineCategoryManagement",
      component: _2d82617b,
      name: "index-generalService-disciplineCategoryManagement"
    }, {
      path: "generalService/hotSpot",
      component: _759cafbb,
      name: "index-generalService-hotSpot"
    }, {
      path: "generalService/onePointOneLevel",
      component: _57ae451c,
      name: "index-generalService-onePointOneLevel"
    }, {
      path: "generalService/referenceScoreCalculate",
      component: _80c2982a,
      name: "index-generalService-referenceScoreCalculate"
    }, {
      path: "generalService/relativeManagement",
      component: _030a2379,
      name: "index-generalService-relativeManagement"
    }, {
      path: "generalService/subjectAssessDataManagement",
      component: _48c887ae,
      name: "index-generalService-subjectAssessDataManagement"
    }, {
      path: "generalService/supplementaryBaseScore",
      component: _1e3083fc,
      name: "index-generalService-supplementaryBaseScore"
    }, {
      path: "generalService/trainingRecord",
      component: _618994d6,
      name: "index-generalService-trainingRecord"
    }, {
      path: "generalService/urbanCompetitiveness",
      component: _09acbbfe,
      name: "index-generalService-urbanCompetitiveness"
    }, {
      path: "generalService/versionManagement",
      component: _39e4d7c7,
      name: "index-generalService-versionManagement"
    }, {
      path: "hmtservice/englishVideo",
      component: _027f26bc,
      name: "index-hmtservice-englishVideo",
      children: [{
        path: "academyIntroduction",
        component: _1a3aa45a,
        name: "index-hmtservice-englishVideo-index-academyIntroduction"
      }, {
        path: "academyIntroduction_unreleased",
        component: _7d824672,
        name: "index-hmtservice-englishVideo-index-academyIntroduction_unreleased"
      }, {
        path: "oralLanguage",
        component: _68b8022e,
        name: "index-hmtservice-englishVideo-index-oralLanguage"
      }]
    }, {
      path: "hmtservice/index_unreleased",
      component: _dcc5c71e,
      name: "index-hmtservice-index_unreleased"
    }, {
      path: "hmtservice/scheme",
      component: _6d75e833,
      name: "index-hmtservice-scheme"
    }, {
      path: "hmtservice/scheme_unreleased",
      component: _49b65fdc,
      name: "index-hmtservice-scheme_unreleased"
    }, {
      path: "information/ArtScore",
      component: _0dad4e40,
      name: "index-information-ArtScore"
    }, {
      path: "information/batch",
      component: _78214dbf,
      name: "index-information-batch"
    }, {
      path: "information/hmkColleges",
      component: _34f710e7,
      name: "index-information-hmkColleges"
    }, {
      path: "information/newsList",
      component: _41ed83c2,
      name: "index-information-newsList"
    }, {
      path: "information/onePointOneLevel",
      component: _5726bc99,
      name: "index-information-onePointOneLevel"
    }, {
      path: "information/Score",
      component: _042d1ef7,
      name: "index-information-Score"
    }, {
      path: "information/speciality",
      component: _59650486,
      name: "index-information-speciality"
    }, {
      path: "information/specialityinfoElective",
      component: _44dfda06,
      name: "index-information-specialityinfoElective"
    }, {
      path: "information/studentList",
      component: _a27c2484,
      name: "index-information-studentList"
    }, {
      path: "information/subjectAssessment",
      component: _6e788f93,
      name: "index-information-subjectAssessment"
    }, {
      path: "information/taiwanColleges",
      component: _42a3a515,
      name: "index-information-taiwanColleges"
    }, {
      path: "information/university",
      component: _3a920a7f,
      name: "index-information-university"
    }, {
      path: "IPADManage/agentProduce",
      component: _4fe70103,
      name: "index-IPADManage-agentProduce"
    }, {
      path: "IPADManage/campus-banner",
      component: _45fb8688,
      name: "index-IPADManage-campus-banner"
    }, {
      path: "IPADManage/campus-information",
      component: _370be2b4,
      name: "index-IPADManage-campus-information"
    }, {
      path: "IPADManage/caseClassification",
      component: _3355029e,
      name: "index-IPADManage-caseClassification"
    }, {
      path: "IPADManage/classicCases",
      component: _25c40139,
      name: "index-IPADManage-classicCases"
    }, {
      path: "IPADManage/corporateCulture-banner",
      component: _90d67144,
      name: "index-IPADManage-corporateCulture-banner"
    }, {
      path: "IPADManage/corporateCulture-Images",
      component: _7dab5fca,
      name: "index-IPADManage-corporateCulture-Images"
    }, {
      path: "IPADManage/IndexConfiguration",
      component: _19e5d168,
      name: "index-IPADManage-IndexConfiguration"
    }, {
      path: "IPADManage/produce",
      component: _207a0b64,
      name: "index-IPADManage-produce"
    }, {
      path: "lecturerApplication/application",
      component: _a867f6b6,
      name: "index-lecturerApplication-application"
    }, {
      path: "lecturerApplication/applicationReport",
      component: _2986450e,
      name: "index-lecturerApplication-applicationReport"
    }, {
      path: "log/loginLog",
      component: _794e0871,
      name: "index-log-loginLog"
    }, {
      path: "log/operLog",
      component: _23ffa4a0,
      name: "index-log-operLog"
    }, {
      path: "manageDepositX/orderListModal",
      component: _e05ffb94,
      name: "index-manageDepositX-orderListModal"
    }, {
      path: "manageMarginX/orderListModal",
      component: _4ec72376,
      name: "index-manageMarginX-orderListModal"
    }, {
      path: "monthly/monthly",
      component: _d2396e20,
      name: "index-monthly-monthly"
    }, {
      path: "myToolBox/answers",
      component: _47862dd5,
      name: "index-myToolBox-answers"
    }, {
      path: "myToolBox/carryForward",
      component: _f221f340,
      name: "index-myToolBox-carryForward"
    }, {
      path: "myToolBox/informationPackage",
      component: _7368d270,
      name: "index-myToolBox-informationPackage"
    }, {
      path: "myToolBox/libraryManage",
      component: _526f01e0,
      name: "index-myToolBox-libraryManage"
    }, {
      path: "myToolBox/mailList",
      component: _4b27a3eb,
      name: "index-myToolBox-mailList"
    }, {
      path: "myToolBox/mailListManage",
      component: _23e3ef30,
      name: "index-myToolBox-mailListManage"
    }, {
      path: "myToolBox/product",
      component: _668a71cf,
      name: "index-myToolBox-product"
    }, {
      path: "myToolBox/video",
      component: _74b9179b,
      name: "index-myToolBox-video"
    }, {
      path: "opportunityPoint/opportunity",
      component: _98af89a2,
      name: "index-opportunityPoint-opportunity"
    }, {
      path: "order/failOrders",
      component: _2796da9c,
      name: "index-order-failOrders"
    }, {
      path: "order/onlineOrders",
      component: _3b1a4ae7,
      name: "index-order-onlineOrders"
    }, {
      path: "order/onlineRefund",
      component: _236a6bba,
      name: "index-order-onlineRefund"
    }, {
      path: "order/pos",
      component: _d9e0018a,
      name: "index-order-pos"
    }, {
      path: "order/productChange",
      component: _32a9a1a6,
      name: "index-order-productChange"
    }, {
      path: "order/refund",
      component: _3a16e372,
      name: "index-order-refund"
    }, {
      path: "order/sales",
      component: _57590cf3,
      name: "index-order-sales"
    }, {
      path: "order/touristOrders",
      component: _34fa6ede,
      name: "index-order-touristOrders"
    }, {
      path: "padManage/campus",
      component: _4d5eb224,
      name: "index-padManage-campus"
    }, {
      path: "padManage/group",
      component: _086a1cb0,
      name: "index-padManage-group"
    }, {
      path: "padManage/inventory",
      component: _045c344d,
      name: "index-padManage-inventory"
    }, {
      path: "product/offline",
      component: _1b8e8e2b,
      name: "index-product-offline"
    }, {
      path: "product/stock",
      component: _73d9aa44,
      name: "index-product-stock"
    }, {
      path: "quickReferenceTable/add",
      component: _56db8907,
      name: "index-quickReferenceTable-add"
    }, {
      path: "quickReferenceTable/quickReferenceTable",
      component: _997ad114,
      name: "index-quickReferenceTable-quickReferenceTable"
    }, {
      path: "report/achievement",
      component: _08640f02,
      name: "index-report-achievement"
    }, {
      path: "report/campusPerformanceSummary",
      component: _03f69838,
      name: "index-report-campusPerformanceSummary"
    }, {
      path: "report/customerStatisticsReport",
      component: _16e11915,
      name: "index-report-customerStatisticsReport"
    }, {
      path: "report/education",
      component: _47001a78,
      name: "index-report-education"
    }, {
      path: "report/expendReport",
      component: _6d910ad2,
      name: "index-report-expendReport"
    }, {
      path: "report/headquarters",
      component: _c5ff6df2,
      name: "index-report-headquarters"
    }, {
      path: "report/intenReport",
      component: _808b7208,
      name: "index-report-intenReport"
    }, {
      path: "report/lecturerPerformanceRankingTable",
      component: _e39802f2,
      name: "index-report-lecturerPerformanceRankingTable"
    }, {
      path: "report/operationalPerformanceRankingTable",
      component: _6ae6edb9,
      name: "index-report-operationalPerformanceRankingTable"
    }, {
      path: "report/operationsManagerPerformanceReport",
      component: _2b6d7186,
      name: "index-report-operationsManagerPerformanceReport"
    }, {
      path: "report/orderListModal",
      component: _756315e1,
      name: "index-report-orderListModal"
    }, {
      path: "report/performanceReport",
      component: _217a91d7,
      name: "index-report-performanceReport"
    }, {
      path: "report/performanceReportJoin",
      component: _4406debe,
      name: "index-report-performanceReportJoin"
    }, {
      path: "report/productLineTransfer",
      component: _7ed5b45e,
      name: "index-report-productLineTransfer"
    }, {
      path: "report/proIntenReport",
      component: _0cdfe51f,
      name: "index-report-proIntenReport"
    }, {
      path: "report/salesSummaryB2C",
      component: _2fc549ae,
      name: "index-report-salesSummaryB2C"
    }, {
      path: "report/serviceNumberReport",
      component: _c69125fc,
      name: "index-report-serviceNumberReport"
    }, {
      path: "report/serviceProgressReport",
      component: _166b77a6,
      name: "index-report-serviceProgressReport"
    }, {
      path: "report/serviceReport",
      component: _494b0a99,
      name: "index-report-serviceReport"
    }, {
      path: "report/serviceStepReport",
      component: _754cb005,
      name: "index-report-serviceStepReport"
    }, {
      path: "report/teacherAchievementReport",
      component: _caa2373e,
      name: "index-report-teacherAchievementReport"
    }, {
      path: "report/variousRegionsReport",
      component: _a45a1570,
      name: "index-report-variousRegionsReport"
    }, {
      path: "revenues/paymentRecord",
      component: _37e11926,
      name: "index-revenues-paymentRecord"
    }, {
      path: "revenues/refundRecord",
      component: _9ead416e,
      name: "index-revenues-refundRecord"
    }, {
      path: "revenues/transferRecord",
      component: _0beca47c,
      name: "index-revenues-transferRecord"
    }, {
      path: "selfService/planStore",
      component: _33ed375a,
      name: "index-selfService-planStore"
    }, {
      path: "selfService/programme",
      component: _2843363e,
      name: "index-selfService-programme"
    }, {
      path: "serviceSystem/career",
      component: _84c6e6d2,
      name: "index-serviceSystem-career"
    }, {
      path: "serviceSystem/entrancePlanningMap",
      component: _2bb65d46,
      name: "index-serviceSystem-entrancePlanningMap"
    }, {
      path: "serviceSystem/evaluation",
      component: _2946f056,
      name: "index-serviceSystem-evaluation"
    }, {
      path: "serviceSystem/hrpReport",
      component: _59fd1bd7,
      name: "index-serviceSystem-hrpReport"
    }, {
      path: "serviceSystem/learnMethods",
      component: _08b06932,
      name: "index-serviceSystem-learnMethods"
    }, {
      path: "serviceSystem/learnStatus",
      component: _631d9633,
      name: "index-serviceSystem-learnStatus"
    }, {
      path: "serviceSystem/opportunities-plan",
      component: _01891fc4,
      name: "index-serviceSystem-opportunities-plan"
    }, {
      path: "serviceSystem/partnerStudentList",
      component: _3793e82c,
      name: "index-serviceSystem-partnerStudentList"
    }, {
      path: "serviceSystem/serviceConditions",
      component: _741e702c,
      name: "index-serviceSystem-serviceConditions"
    }, {
      path: "serviceSystem/studentReport",
      component: _41528e6c,
      name: "index-serviceSystem-studentReport"
    }, {
      path: "serviceSystem/volunteer",
      component: _9db8fc32,
      name: "index-serviceSystem-volunteer"
    }, {
      path: "serviceSystemArt/opportunities-plan",
      component: _57812cbd,
      name: "index-serviceSystemArt-opportunities-plan"
    }, {
      path: "serviceSystemArt/opportunities-plan-xk",
      component: _d8c6f3ce,
      name: "index-serviceSystemArt-opportunities-plan-xk"
    }, {
      path: "stationNotification/myReceived",
      component: _03abf0ab,
      name: "index-stationNotification-myReceived"
    }, {
      path: "stationNotification/myRelease",
      component: _696fd393,
      name: "index-stationNotification-myRelease"
    }, {
      path: "stationNotification/taskSituation",
      component: _348748d1,
      name: "index-stationNotification-taskSituation"
    }, {
      path: "system/configs",
      component: _7952c082,
      name: "index-system-configs"
    }, {
      path: "system/menu",
      component: _ca151bb2,
      name: "index-system-menu"
    }, {
      path: "system/org",
      component: _4ad2a6f2,
      name: "index-system-org"
    }, {
      path: "system/role",
      component: _108ba704,
      name: "index-system-role"
    }, {
      path: "test/crud",
      component: _3fe27140,
      name: "index-test-crud"
    }, {
      path: "weekly/weekly",
      component: _5a785818,
      name: "index-weekly-weekly"
    }, {
      path: "workbench/approvalDealtService",
      component: _202e1f6b,
      name: "index-workbench-approvalDealtService"
    }, {
      path: "workbench/eduDealtService",
      component: _191b9338,
      name: "index-workbench-eduDealtService"
    }, {
      path: "workbench/finishedService",
      component: _39702e38,
      name: "index-workbench-finishedService"
    }, {
      path: "workbench/handleDone",
      component: _45f840c8,
      name: "index-workbench-handleDone"
    }, {
      path: "workbench/myToDo",
      component: _70c886b0,
      name: "index-workbench-myToDo"
    }, {
      path: "workbench/notice",
      component: _660d8993,
      name: "index-workbench-notice"
    }, {
      path: "workbench/noticeAdmin",
      component: _35dde42c,
      name: "index-workbench-noticeAdmin"
    }, {
      path: "workbench/salesDealtService",
      component: _e055e564,
      name: "index-workbench-salesDealtService"
    }, {
      path: "workbench/serviceDealtService",
      component: _4bf40db7,
      name: "index-workbench-serviceDealtService"
    }, {
      path: "artExamination/university/orderListModal",
      component: _3b813f68,
      name: "index-artExamination-university-orderListModal"
    }, {
      path: "artExamination/university/orderListModalEdit",
      component: _fd8db914,
      name: "index-artExamination-university-orderListModalEdit"
    }, {
      path: "customer/livingCustomer/customerListModal",
      component: _3e43673f,
      name: "index-customer-livingCustomer-customerListModal"
    }, {
      path: "customer/zonghe/honourPreviewModal",
      component: _7e2beda8,
      name: "index-customer-zonghe-honourPreviewModal"
    }, {
      path: "customer/zonghe/newPassPreviewModal",
      component: _ac7b4af0,
      name: "index-customer-zonghe-newPassPreviewModal"
    }, {
      path: "customer/zonghe/oldPassPreviewModal",
      component: _9b7c54e2,
      name: "index-customer-zonghe-oldPassPreviewModal"
    }, {
      path: "customer/zonghe/practicePreviewModal",
      component: _21539084,
      name: "index-customer-zonghe-practicePreviewModal"
    }, {
      path: "examination/analysis/viewInfo",
      component: _7a06c3cd,
      name: "index-examination-analysis-viewInfo"
    }, {
      path: "generalService/hotSpot/hotSpotModal",
      component: _76f503b6,
      name: "index-generalService-hotSpot-hotSpotModal"
    }, {
      path: "hmtservice/application/addApplication",
      component: _0508a79c,
      name: "index-hmtservice-application-addApplication"
    }, {
      path: "hmtservice/application/application",
      component: _4e80d173,
      name: "index-hmtservice-application-application"
    }, {
      path: "hmtservice/application/backMaterials",
      component: _7093a1e8,
      name: "index-hmtservice-application-backMaterials"
    }, {
      path: "hmtservice/application/materials",
      component: _414e250f,
      name: "index-hmtservice-application-materials"
    }, {
      path: "hmtservice/application/pushMaterials",
      component: _71606295,
      name: "index-hmtservice-application-pushMaterials"
    }, {
      path: "hmtservice/coverLetter/coverLetter",
      component: _1a64cbcd,
      name: "index-hmtservice-coverLetter-coverLetter"
    }, {
      path: "hmtservice/coverLetter/guidance",
      component: _be8d5810,
      name: "index-hmtservice-coverLetter-guidance"
    }, {
      path: "hmtservice/coverLetter/upLoad",
      component: _ddf17f7e,
      name: "index-hmtservice-coverLetter-upLoad"
    }, {
      path: "hmtservice/coverLetter/upSignup",
      component: _cccec29a,
      name: "index-hmtservice-coverLetter-upSignup"
    }, {
      path: "hmtservice/coverLetter/upSignUpNew",
      component: _1ec81dfd,
      name: "index-hmtservice-coverLetter-upSignUpNew"
    }, {
      path: "hmtservice/englishVideo/index_unreleased",
      component: _1a9a51e9,
      name: "index-hmtservice-englishVideo-index_unreleased"
    }, {
      path: "hmtservice/interviwe/addAdmissionModel",
      component: _022f6011,
      name: "index-hmtservice-interviwe-addAdmissionModel"
    }, {
      path: "hmtservice/interviwe/addTrainModel",
      component: _4170ad1c,
      name: "index-hmtservice-interviwe-addTrainModel"
    }, {
      path: "hmtservice/interviwe/admission",
      component: _4b353479,
      name: "index-hmtservice-interviwe-admission"
    }, {
      path: "hmtservice/interviwe/admissionStatus",
      component: _045ceacb,
      name: "index-hmtservice-interviwe-admissionStatus"
    }, {
      path: "hmtservice/interviwe/materials",
      component: _5d86549f,
      name: "index-hmtservice-interviwe-materials"
    }, {
      path: "hmtservice/interviwe/trainManage",
      component: _b5bf4c06,
      name: "index-hmtservice-interviwe-trainManage"
    }, {
      path: "hmtservice/interviwe/trainPlan",
      component: _44c6347e,
      name: "index-hmtservice-interviwe-trainPlan"
    }, {
      path: "hmtservice/interviwe/video",
      component: _478f3e2e,
      name: "index-hmtservice-interviwe-video"
    }, {
      path: "hmtservice/plan/HM",
      component: _9ae269e6,
      name: "index-hmtservice-plan-HM"
    }, {
      path: "hmtservice/plan/T",
      component: _613550fc,
      name: "index-hmtservice-plan-T"
    }, {
      path: "IPADManage/agentManage/agentCardManage",
      component: _4ca9d1e3,
      name: "index-IPADManage-agentManage-agentCardManage"
    }, {
      path: "IPADManage/agentManage/agentCustomer",
      component: _138192ac,
      name: "index-IPADManage-agentManage-agentCustomer"
    }, {
      path: "IPADManage/agentManage/agentInformation",
      component: _3be90998,
      name: "index-IPADManage-agentManage-agentInformation"
    }, {
      path: "IPADManage/agentManage/agentList",
      component: _b2613628,
      name: "index-IPADManage-agentManage-agentList"
    }, {
      path: "IPADManage/agentManage/agentProfit",
      component: _1b01ba52,
      name: "index-IPADManage-agentManage-agentProfit"
    }, {
      path: "IPADManage/agentManage/agentProfit2",
      component: _f9553714,
      name: "index-IPADManage-agentManage-agentProfit2"
    }, {
      path: "IPADManage/agentManage/cardUsageRecord",
      component: _c7a972ea,
      name: "index-IPADManage-agentManage-cardUsageRecord"
    }, {
      path: "IPADManage/agentManage/orgProductOffline",
      component: _73a31561,
      name: "index-IPADManage-agentManage-orgProductOffline"
    }, {
      path: "IPADManage/agentManage/productManage",
      component: _043e42c6,
      name: "index-IPADManage-agentManage-productManage"
    }, {
      path: "IPADManage/agentManage/revenueBreakdownQuery",
      component: _32fab90c,
      name: "index-IPADManage-agentManage-revenueBreakdownQuery"
    }, {
      path: "IPADManage/agentManage/revenueQuery",
      component: _4ec6bb19,
      name: "index-IPADManage-agentManage-revenueQuery"
    }, {
      path: "IPADManage/agentManage/searchCard",
      component: _3bc32936,
      name: "index-IPADManage-agentManage-searchCard"
    }, {
      path: "notice/components/orderNotification",
      component: _76ebb45f,
      name: "index-notice-components-orderNotification"
    }, {
      path: "noticeOnline/components/myReceived",
      component: _7ec98420,
      name: "index-noticeOnline-components-myReceived"
    }, {
      path: "noticeOnline/components/mySend",
      component: _3fc4b8d7,
      name: "index-noticeOnline-components-mySend"
    }, {
      path: "opportunityPoint/opportunity/add",
      component: _73450e84,
      name: "index-opportunityPoint-opportunity-add"
    }, {
      path: "product/offline/productListModal",
      component: _27175e92,
      name: "index-product-offline-productListModal"
    }, {
      path: "product/stock/addStockDrawer",
      component: _7aac3dea,
      name: "index-product-stock-addStockDrawer"
    }, {
      path: "product/stock/addStockDrawerForArt",
      component: _0b83a738,
      name: "index-product-stock-addStockDrawerForArt"
    }, {
      path: "product/stock/addStockDrawerForHrp",
      component: _6c516d27,
      name: "index-product-stock-addStockDrawerForHrp"
    }, {
      path: "product/stock/addStockDrawerForSchoolPartner",
      component: _2ec63e16,
      name: "index-product-stock-addStockDrawerForSchoolPartner"
    }, {
      path: "product/stock/addStockDrawerForZP",
      component: _5a081ca5,
      name: "index-product-stock-addStockDrawerForZP"
    }, {
      path: "product/stock/addStockDrawerForZPSchoolPartner",
      component: _7d6a9a3f,
      name: "index-product-stock-addStockDrawerForZPSchoolPartner"
    }, {
      path: "product/stock/orderListModal",
      component: _f608fdb6,
      name: "index-product-stock-orderListModal"
    }, {
      path: "product/stock/RefundStockDrawer",
      component: _e403030a,
      name: "index-product-stock-RefundStockDrawer"
    }, {
      path: "product/stock/selectProductModal",
      component: _64d653be,
      name: "index-product-stock-selectProductModal"
    }, {
      path: "product/stock/stockRefund",
      component: _3ae0673a,
      name: "index-product-stock-stockRefund"
    }, {
      path: "reconcilation/components/table-expand",
      component: _3a7f8774,
      name: "index-reconcilation-components-table-expand"
    }, {
      path: "report/evaluationReport/report1",
      component: _38573b44,
      name: "index-report-evaluationReport-report1"
    }, {
      path: "report/evaluationReport/report2",
      component: _383b0c42,
      name: "index-report-evaluationReport-report2"
    }, {
      path: "schemeInspect/components/logo",
      component: _05224949,
      name: "index-schemeInspect-components-logo"
    }, {
      path: "schemeInspect/components/pageLayout",
      component: _fda47a92,
      name: "index-schemeInspect-components-pageLayout"
    }, {
      path: "schemeInspect/components/pageTitle",
      component: _4a569c5b,
      name: "index-schemeInspect-components-pageTitle"
    }, {
      path: "schemeInspect/pages/1",
      component: _6a8aae2a,
      name: "index-schemeInspect-pages-1"
    }, {
      path: "schemeInspect/pages/2",
      component: _6a6e7f28,
      name: "index-schemeInspect-pages-2"
    }, {
      path: "schemeInspect/pages/3",
      component: _6a525026,
      name: "index-schemeInspect-pages-3"
    }, {
      path: "selfService/components/DesignThoughtModal",
      component: _8ba286ec,
      name: "index-selfService-components-DesignThoughtModal"
    }, {
      path: "selfService/components/LeaveMessageModal",
      component: _abc9ed56,
      name: "index-selfService-components-LeaveMessageModal"
    }, {
      path: "selfService/components/seniority",
      component: _2ac2e394,
      name: "index-selfService-components-seniority"
    }, {
      path: "selfService/components/studentInfo",
      component: _88fd5c7e,
      name: "index-selfService-components-studentInfo"
    }, {
      path: "selfService/stepFive/confirmationPlan",
      component: _b3b326a4,
      name: "index-selfService-stepFive-confirmationPlan"
    }, {
      path: "selfService/stepFive/finalSolutionLibrary",
      component: _7dd6d15c,
      name: "index-selfService-stepFive-finalSolutionLibrary"
    }, {
      path: "selfService/stepFive/universityBrochure",
      component: _75fbd482,
      name: "index-selfService-stepFive-universityBrochure"
    }, {
      path: "selfService/stepFour/addApplication",
      component: _62f7cc2b,
      name: "index-selfService-stepFour-addApplication"
    }, {
      path: "selfService/stepFour/backMaterials",
      component: _4213a10e,
      name: "index-selfService-stepFour-backMaterials"
    }, {
      path: "selfService/stepFour/coverLetter",
      component: _498aeb9e,
      name: "index-selfService-stepFour-coverLetter"
    }, {
      path: "selfService/stepFour/guideVideo",
      component: _1a2f371b,
      name: "index-selfService-stepFour-guideVideo"
    }, {
      path: "selfService/stepFour/materials",
      component: _281fb9c0,
      name: "index-selfService-stepFour-materials"
    }, {
      path: "selfService/stepFour/pushMaterials",
      component: _407a1fb4,
      name: "index-selfService-stepFour-pushMaterials"
    }, {
      path: "selfService/stepSix/fillinVideo",
      component: _1ea0fe79,
      name: "index-selfService-stepSix-fillinVideo"
    }, {
      path: "selfService/stepSix/schemeScreenshot",
      component: _302400d5,
      name: "index-selfService-stepSix-schemeScreenshot"
    }, {
      path: "selfService/stepSix/upLoad",
      component: _56cd2cea,
      name: "index-selfService-stepSix-upLoad"
    }, {
      path: "selfService/stepThree/planStore",
      component: _0df09186,
      name: "index-selfService-stepThree-planStore"
    }, {
      path: "selfService/stepThree/recruitment",
      component: _cdaa93be,
      name: "index-selfService-stepThree-recruitment"
    }, {
      path: "selfService/stepThree/recruitStudent",
      component: _3cf9d34e,
      name: "index-selfService-stepThree-recruitStudent"
    }, {
      path: "selfService/stepTwo/guideVideo",
      component: _eb6800c2,
      name: "index-selfService-stepTwo-guideVideo"
    }, {
      path: "selfService/stepTwo/match",
      component: _95726996,
      name: "index-selfService-stepTwo-match"
    }, {
      path: "selfService/stepTwo/planDesign",
      component: _0ddfc9f2,
      name: "index-selfService-stepTwo-planDesign"
    }, {
      path: "selfService/stepTwo/seniority",
      component: _8cfa0524,
      name: "index-selfService-stepTwo-seniority"
    }, {
      path: "selfService/stepTwo/studentPassageway",
      component: _ffd6c928,
      name: "index-selfService-stepTwo-studentPassageway"
    }, {
      path: "selfService/stepTwo/videoDrawer",
      component: _1912e53c,
      name: "index-selfService-stepTwo-videoDrawer"
    }, {
      path: "serviceSystem/commonFile/citySelect",
      component: _ab4e66ae,
      name: "index-serviceSystem-commonFile-citySelect"
    }, {
      path: "serviceSystem/commonFile/complateServiceModal",
      component: _73ca7aa2,
      name: "index-serviceSystem-commonFile-complateServiceModal"
    }, {
      path: "serviceSystem/commonFile/designThought",
      component: _c0db8fee,
      name: "index-serviceSystem-commonFile-designThought"
    }, {
      path: "serviceSystem/commonFile/designThoughtForOp",
      component: _3bb23f31,
      name: "index-serviceSystem-commonFile-designThoughtForOp"
    }, {
      path: "serviceSystem/commonFile/designThoughtForSpecal",
      component: _be14a814,
      name: "index-serviceSystem-commonFile-designThoughtForSpecal"
    }, {
      path: "serviceSystem/commonFile/exportOption",
      component: _0eb4042b,
      name: "index-serviceSystem-commonFile-exportOption"
    }, {
      path: "serviceSystem/commonFile/leaveMessage",
      component: _630654b2,
      name: "index-serviceSystem-commonFile-leaveMessage"
    }, {
      path: "serviceSystem/commonFile/schemeInspect",
      component: _a0e57f86,
      name: "index-serviceSystem-commonFile-schemeInspect"
    }, {
      path: "serviceSystem/commonFile/scoreStatisticsListModal",
      component: _04db223c,
      name: "index-serviceSystem-commonFile-scoreStatisticsListModal"
    }, {
      path: "serviceSystem/commonFile/serviceStep",
      component: _910fa9a2,
      name: "index-serviceSystem-commonFile-serviceStep"
    }, {
      path: "serviceSystem/commonFile/specialityPackage",
      component: _1ff214bf,
      name: "index-serviceSystem-commonFile-specialityPackage"
    }, {
      path: "serviceSystem/commonFile/specialityPackageaAdd",
      component: _c6f8fc82,
      name: "index-serviceSystem-commonFile-specialityPackageaAdd"
    }, {
      path: "serviceSystem/commonFile/specialityTreeModal",
      component: _63cd7968,
      name: "index-serviceSystem-commonFile-specialityTreeModal"
    }, {
      path: "serviceSystem/commonFile/specialityTreeNew",
      component: _7624c39b,
      name: "index-serviceSystem-commonFile-specialityTreeNew"
    }, {
      path: "serviceSystem/commonFile/specialRequirementsModal",
      component: _7f725ea6,
      name: "index-serviceSystem-commonFile-specialRequirementsModal"
    }, {
      path: "serviceSystem/commonFile/studentInfo",
      component: _74e0c4d2,
      name: "index-serviceSystem-commonFile-studentInfo"
    }, {
      path: "serviceSystem/commonFile/studentInfoDetailModal",
      component: _86caae16,
      name: "index-serviceSystem-commonFile-studentInfoDetailModal"
    }, {
      path: "serviceSystem/commonFile/studentList",
      component: _0b297187,
      name: "index-serviceSystem-commonFile-studentList"
    }, {
      path: "serviceSystem/commonFile/studentUpdate",
      component: _03ba481c,
      name: "index-serviceSystem-commonFile-studentUpdate"
    }, {
      path: "serviceSystem/general-province/estimate-plan",
      component: _8af873a6,
      name: "index-serviceSystem-general-province-estimate-plan"
    }, {
      path: "serviceSystem/general-province/final-plan",
      component: _4db22ed7,
      name: "index-serviceSystem-general-province-final-plan"
    }, {
      path: "serviceSystem/general-province/initial-plan",
      component: _1d9b4c49,
      name: "index-serviceSystem-general-province-initial-plan"
    }, {
      path: "serviceSystem/general-province/scheme",
      component: _688ce9c8,
      name: "index-serviceSystem-general-province-scheme"
    }, {
      path: "serviceSystem/general-province/smart-report",
      component: _46b77a6f,
      name: "index-serviceSystem-general-province-smart-report"
    }, {
      path: "serviceSystem/new-version/estimate-plan",
      component: _d8244cb2,
      name: "index-serviceSystem-new-version-estimate-plan"
    }, {
      path: "serviceSystem/new-version/final-plan",
      component: _52eb5d9d,
      name: "index-serviceSystem-new-version-final-plan"
    }, {
      path: "serviceSystem/new-version/initial-plan",
      component: _8d783ce2,
      name: "index-serviceSystem-new-version-initial-plan"
    }, {
      path: "serviceSystem/new-version/scheme",
      component: _21b50ce2,
      name: "index-serviceSystem-new-version-scheme"
    }, {
      path: "serviceSystem/new-version/smart-report",
      component: _3b3fe096,
      name: "index-serviceSystem-new-version-smart-report"
    }, {
      path: "serviceSystem/newRegulation/estimate-plan",
      component: _d74378ba,
      name: "index-serviceSystem-newRegulation-estimate-plan"
    }, {
      path: "serviceSystem/newRegulation/final-plan",
      component: _524cf57b,
      name: "index-serviceSystem-newRegulation-final-plan"
    }, {
      path: "serviceSystem/newRegulation/initial-plan",
      component: _7f86a2ad,
      name: "index-serviceSystem-newRegulation-initial-plan"
    }, {
      path: "serviceSystem/newRegulation/scheme",
      component: _7c575500,
      name: "index-serviceSystem-newRegulation-scheme"
    }, {
      path: "serviceSystem/occupations/occupation",
      component: _26e0e56a,
      name: "index-serviceSystem-occupations-occupation"
    }, {
      path: "serviceSystem/occupations/planning",
      component: _ba17fbc6,
      name: "index-serviceSystem-occupations-planning"
    }, {
      path: "serviceSystem/occupations/report",
      component: _a068f718,
      name: "index-serviceSystem-occupations-report"
    }, {
      path: "serviceSystem/occupations/scheme",
      component: _c48968b6,
      name: "index-serviceSystem-occupations-scheme"
    }, {
      path: "serviceSystem/opportunities-plan/scheme",
      component: _c8109b68,
      name: "index-serviceSystem-opportunities-plan-scheme"
    }, {
      path: "serviceSystem/partnerStudentList/addModal",
      component: _d46ffcb8,
      name: "index-serviceSystem-partnerStudentList-addModal"
    }, {
      path: "serviceSystem/partnerStudentList/serviceStep",
      component: _783a3a8e,
      name: "index-serviceSystem-partnerStudentList-serviceStep"
    }, {
      path: "serviceSystem/professionalGroup/estimate-plan",
      component: _ce542fd8,
      name: "index-serviceSystem-professionalGroup-estimate-plan"
    }, {
      path: "serviceSystem/professionalGroup/final-plan",
      component: _0552ae50,
      name: "index-serviceSystem-professionalGroup-final-plan"
    }, {
      path: "serviceSystem/professionalGroup/initial-plan",
      component: _6f19d182,
      name: "index-serviceSystem-professionalGroup-initial-plan"
    }, {
      path: "serviceSystem/professionalGroup/scheme",
      component: _2aeeaf15,
      name: "index-serviceSystem-professionalGroup-scheme"
    }, {
      path: "serviceSystem/professionNew/estimate-plan",
      component: _538b8b80,
      name: "index-serviceSystem-professionNew-estimate-plan"
    }, {
      path: "serviceSystem/professionNew/final-plan",
      component: _20d1a264,
      name: "index-serviceSystem-professionNew-final-plan"
    }, {
      path: "serviceSystem/professionNew/initial-plan",
      component: _b2a7ded4,
      name: "index-serviceSystem-professionNew-initial-plan"
    }, {
      path: "serviceSystem/professionNew/scheme",
      component: _1092cd29,
      name: "index-serviceSystem-professionNew-scheme"
    }, {
      path: "serviceSystem/volunteer/crm-slider",
      component: _5e2d91a4,
      name: "index-serviceSystem-volunteer-crm-slider"
    }, {
      path: "serviceSystem/volunteer/filter",
      component: _72c76676,
      name: "index-serviceSystem-volunteer-filter"
    }, {
      path: "serviceSystem/volunteer/majorGroup",
      component: _b0d03afe,
      name: "index-serviceSystem-volunteer-majorGroup"
    }, {
      path: "serviceSystem/volunteer/majorGroupPrint",
      component: _a27a7f48,
      name: "index-serviceSystem-volunteer-majorGroupPrint"
    }, {
      path: "serviceSystem/volunteer/majorGroupView",
      component: _2594eb74,
      name: "index-serviceSystem-volunteer-majorGroupView"
    }, {
      path: "serviceSystem/volunteer/majorNow",
      component: _082bc5d8,
      name: "index-serviceSystem-volunteer-majorNow"
    }, {
      path: "serviceSystem/volunteer/majorNowPrint",
      component: _bacb4936,
      name: "index-serviceSystem-volunteer-majorNowPrint"
    }, {
      path: "serviceSystem/volunteer/majorNowView",
      component: _4fe9ea1d,
      name: "index-serviceSystem-volunteer-majorNowView"
    }, {
      path: "serviceSystem/volunteer/modal",
      component: _6299ee42,
      name: "index-serviceSystem-volunteer-modal"
    }, {
      path: "serviceSystem/volunteer/qrCode",
      component: _1732192e,
      name: "index-serviceSystem-volunteer-qrCode"
    }, {
      path: "serviceSystem/volunteer/selectSpecialityModal",
      component: _8248685e,
      name: "index-serviceSystem-volunteer-selectSpecialityModal"
    }, {
      path: "serviceSystem/volunteer/smartModal",
      component: _5caa519f,
      name: "index-serviceSystem-volunteer-smartModal"
    }, {
      path: "serviceSystemArt/commonFile/designThought",
      component: _105016b0,
      name: "index-serviceSystemArt-commonFile-designThought"
    }, {
      path: "serviceSystemArt/commonFile/designThoughtForOp",
      component: _24f48df2,
      name: "index-serviceSystemArt-commonFile-designThoughtForOp"
    }, {
      path: "serviceSystemArt/commonFile/hm",
      component: _465b6728,
      name: "index-serviceSystemArt-commonFile-hm"
    }, {
      path: "serviceSystemArt/commonFile/hmDesignThoughtModal",
      component: _6935518c,
      name: "index-serviceSystemArt-commonFile-hmDesignThoughtModal"
    }, {
      path: "serviceSystemArt/commonFile/hmLeaveMessageModal",
      component: _3f4e58a5,
      name: "index-serviceSystemArt-commonFile-hmLeaveMessageModal"
    }, {
      path: "serviceSystemArt/commonFile/hmPreview",
      component: _8457b8a0,
      name: "index-serviceSystemArt-commonFile-hmPreview"
    }, {
      path: "serviceSystemArt/commonFile/hmScheme",
      component: _faa91b26,
      name: "index-serviceSystemArt-commonFile-hmScheme"
    }, {
      path: "serviceSystemArt/commonFile/serviceStep",
      component: _f61af8e4,
      name: "index-serviceSystemArt-commonFile-serviceStep"
    }, {
      path: "serviceSystemArt/general-province/estimate-plan",
      component: _2f708c4c,
      name: "index-serviceSystemArt-general-province-estimate-plan"
    }, {
      path: "serviceSystemArt/general-province/final-plan",
      component: _1bbd3518,
      name: "index-serviceSystemArt-general-province-final-plan"
    }, {
      path: "serviceSystemArt/general-province/initial-plan",
      component: _d604736c,
      name: "index-serviceSystemArt-general-province-initial-plan"
    }, {
      path: "serviceSystemArt/general-province/scheme",
      component: _96084c46,
      name: "index-serviceSystemArt-general-province-scheme"
    }, {
      path: "serviceSystemArt/general-province/smart-report",
      component: _83cc1720,
      name: "index-serviceSystemArt-general-province-smart-report"
    }, {
      path: "serviceSystemArt/new-regulation/estimate-plan",
      component: _130526cb,
      name: "index-serviceSystemArt-new-regulation-estimate-plan"
    }, {
      path: "serviceSystemArt/new-regulation/final-plan",
      component: _8b05b95a,
      name: "index-serviceSystemArt-new-regulation-final-plan"
    }, {
      path: "serviceSystemArt/new-regulation/initial-plan",
      component: _c73a8af6,
      name: "index-serviceSystemArt-new-regulation-initial-plan"
    }, {
      path: "serviceSystemArt/new-regulation/scheme",
      component: _16b82ed8,
      name: "index-serviceSystemArt-new-regulation-scheme"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan",
      component: _35d77c28,
      name: "index-serviceSystemArt-new-version-estimate-plan"
    }, {
      path: "serviceSystemArt/new-version/final-plan",
      component: _62b3b2bc,
      name: "index-serviceSystemArt-new-version-final-plan"
    }, {
      path: "serviceSystemArt/new-version/initial-plan",
      component: _0f692a24,
      name: "index-serviceSystemArt-new-version-initial-plan"
    }, {
      path: "serviceSystemArt/new-version/scheme",
      component: _79fac981,
      name: "index-serviceSystemArt-new-version-scheme"
    }, {
      path: "serviceSystemArt/new-version/smart-report",
      component: _21679914,
      name: "index-serviceSystemArt-new-version-smart-report"
    }, {
      path: "serviceSystemArt/occupations/occupation",
      component: _07503b2c,
      name: "index-serviceSystemArt-occupations-occupation"
    }, {
      path: "serviceSystemArt/occupations/planning",
      component: _00bd12fc,
      name: "index-serviceSystemArt-occupations-planning"
    }, {
      path: "serviceSystemArt/occupations/report",
      component: _08114113,
      name: "index-serviceSystemArt-occupations-report"
    }, {
      path: "serviceSystemArt/occupations/scheme",
      component: _13fdef78,
      name: "index-serviceSystemArt-occupations-scheme"
    }, {
      path: "serviceSystemArt/opportunities-plan-xk/scheme",
      component: _4a28081e,
      name: "index-serviceSystemArt-opportunities-plan-xk-scheme"
    }, {
      path: "serviceSystemArt/opportunities-plan/page",
      component: _571dd618,
      name: "index-serviceSystemArt-opportunities-plan-page"
    }, {
      path: "serviceSystemArt/opportunities-plan/scheme",
      component: _3de154cd,
      name: "index-serviceSystemArt-opportunities-plan-scheme"
    }, {
      path: "serviceSystemArt/serviceConditions/1",
      component: _c1e7986c,
      name: "index-serviceSystemArt-serviceConditions-1"
    }, {
      path: "system/components/editDateDrawer",
      component: _11ef6ce6,
      name: "index-system-components-editDateDrawer"
    }, {
      path: "system/org/index_backup",
      component: _69f41f5f,
      name: "index-system-org-index_backup"
    }, {
      path: "aiReporting/appletProductShare/component/editDrawer",
      component: _36926c6e,
      name: "index-aiReporting-appletProductShare-component-editDrawer"
    }, {
      path: "aiReporting/creditCards/componts/editDialog",
      component: _6842b42b,
      name: "index-aiReporting-creditCards-componts-editDialog"
    }, {
      path: "aiReporting/feedbackStatistics/componts/editDialog",
      component: _121d0901,
      name: "index-aiReporting-feedbackStatistics-componts-editDialog"
    }, {
      path: "aiReporting/gptfeedback/componts/editDialog",
      component: _23edb91e,
      name: "index-aiReporting-gptfeedback-componts-editDialog"
    }, {
      path: "aiReporting/headQuarters/components/addModal",
      component: _dd504cde,
      name: "index-aiReporting-headQuarters-components-addModal"
    }, {
      path: "aiReporting/headQuarters/components/codeLibrary",
      component: _601177ce,
      name: "index-aiReporting-headQuarters-components-codeLibrary"
    }, {
      path: "aiReporting/headQuarters/components/vipCard",
      component: _20e964d8,
      name: "index-aiReporting-headQuarters-components-vipCard"
    }, {
      path: "aiReporting/redemptionCode/components/addModal",
      component: _42bb0902,
      name: "index-aiReporting-redemptionCode-components-addModal"
    }, {
      path: "aiReporting/redemptionCode/components/codeLibrary",
      component: _d575d9f0,
      name: "index-aiReporting-redemptionCode-components-codeLibrary"
    }, {
      path: "aiReporting/redemptionCode/components/vipModal",
      component: _40366506,
      name: "index-aiReporting-redemptionCode-components-vipModal"
    }, {
      path: "aiReporting/timeAxis/components/timeDrawer",
      component: _1dbf82ea,
      name: "index-aiReporting-timeAxis-components-timeDrawer"
    }, {
      path: "artExamination/academic/components/add",
      component: _489f194c,
      name: "index-artExamination-academic-components-add"
    }, {
      path: "artExamination/onePointOneLevelArt/components/edit",
      component: _6b0620ce,
      name: "index-artExamination-onePointOneLevelArt-components-edit"
    }, {
      path: "artExamination/policy/components/add",
      component: _c692ec62,
      name: "index-artExamination-policy-components-add"
    }, {
      path: "company/courselearning/components/editCategory",
      component: _764757b0,
      name: "index-company-courselearning-components-editCategory"
    }, {
      path: "company/CourseLearningProgress/components/table-expand",
      component: _7d2c9b06,
      name: "index-company-CourseLearningProgress-components-table-expand"
    }, {
      path: "comprehensive/application/components/add",
      component: _865e3066,
      name: "index-comprehensive-application-components-add"
    }, {
      path: "comprehensive/coverLetter/components/add",
      component: _9dadd580,
      name: "index-comprehensive-coverLetter-components-add"
    }, {
      path: "comprehensive/matchIntroduce/components/add",
      component: _27813167,
      name: "index-comprehensive-matchIntroduce-components-add"
    }, {
      path: "comprehensive/qualitySpecialityInfo/components/add",
      component: _5779c04a,
      name: "index-comprehensive-qualitySpecialityInfo-components-add"
    }, {
      path: "comprehensive/universityManage/components/add",
      component: _875488e4,
      name: "index-comprehensive-universityManage-components-add"
    }, {
      path: "comprehensive/videoManagement/components/add",
      component: _3dd85c3f,
      name: "index-comprehensive-videoManagement-components-add"
    }, {
      path: "comprehensive/videoManagement/components/player",
      component: _0ed57108,
      name: "index-comprehensive-videoManagement-components-player"
    }, {
      path: "comprehensive/videoManagement/components/videoList",
      component: _5e2b5ed7,
      name: "index-comprehensive-videoManagement-components-videoList"
    }, {
      path: "generalService/disciplineCategoryManagement/components/updateDrawer",
      component: _35b97948,
      name: "index-generalService-disciplineCategoryManagement-components-updateDrawer"
    }, {
      path: "hmtservice/interviwe/materials/addMaterial",
      component: _f069f416,
      name: "index-hmtservice-interviwe-materials-addMaterial"
    }, {
      path: "hmtservice/interviwe/video/videoDrawer",
      component: _4959d6a8,
      name: "index-hmtservice-interviwe-video-videoDrawer"
    }, {
      path: "information/newsList/components/newsDetail",
      component: _231851e6,
      name: "index-information-newsList-components-newsDetail"
    }, {
      path: "information/newsList/components/push",
      component: _2f31cee3,
      name: "index-information-newsList-components-push"
    }, {
      path: "information/speciality/components/detail",
      component: _ef3f11c4,
      name: "index-information-speciality-components-detail"
    }, {
      path: "information/speciality/components/push",
      component: _133baab2,
      name: "index-information-speciality-components-push"
    }, {
      path: "myToolBox/answers/components/editClassify",
      component: _69f43a6c,
      name: "index-myToolBox-answers-components-editClassify"
    }, {
      path: "myToolBox/answers/components/editDescribe",
      component: _398b4391,
      name: "index-myToolBox-answers-components-editDescribe"
    }, {
      path: "myToolBox/answers/components/feedback",
      component: _ac732bbe,
      name: "index-myToolBox-answers-components-feedback"
    }, {
      path: "myToolBox/libraryManage/components/editCategory",
      component: _233200e2,
      name: "index-myToolBox-libraryManage-components-editCategory"
    }, {
      path: "myToolBox/libraryManage/components/editLibrary",
      component: _3b11008c,
      name: "index-myToolBox-libraryManage-components-editLibrary"
    }, {
      path: "notice/components/stationNotification/myReceived",
      component: _3f83b1e6,
      name: "index-notice-components-stationNotification-myReceived"
    }, {
      path: "notice/components/stationNotification/myRelease",
      component: _27276e1e,
      name: "index-notice-components-stationNotification-myRelease"
    }, {
      path: "padManage/inventory/components/balance",
      component: _4c7a98f8,
      name: "index-padManage-inventory-components-balance"
    }, {
      path: "padManage/inventory/components/detail",
      component: _22399736,
      name: "index-padManage-inventory-components-detail"
    }, {
      path: "selfService/components/stepThree/recruitmentModel",
      component: _165f7ebc,
      name: "index-selfService-components-stepThree-recruitmentModel"
    }, {
      path: "selfService/components/stepTwo/excellentList",
      component: _36bcc786,
      name: "index-selfService-components-stepTwo-excellentList"
    }, {
      path: "selfService/components/stepTwo/excellentModel",
      component: _f95f8bcc,
      name: "index-selfService-components-stepTwo-excellentModel"
    }, {
      path: "selfService/components/stepTwo/passwayList",
      component: _6fbbad85,
      name: "index-selfService-components-stepTwo-passwayList"
    }, {
      path: "selfService/components/stepTwo/passwayModel",
      component: _5b7851d2,
      name: "index-selfService-components-stepTwo-passwayModel"
    }, {
      path: "selfService/components/stepTwo/seniorityList",
      component: _3f5cdef6,
      name: "index-selfService-components-stepTwo-seniorityList"
    }, {
      path: "selfService/stepFive/components/DesignThoughtModal",
      component: _217fd6aa,
      name: "index-selfService-stepFive-components-DesignThoughtModal"
    }, {
      path: "selfService/stepFive/components/LeaveMessageModal",
      component: _4544add8,
      name: "index-selfService-stepFive-components-LeaveMessageModal"
    }, {
      path: "selfService/stepFive/components/recruitmentModel",
      component: _2a046574,
      name: "index-selfService-stepFive-components-recruitmentModel"
    }, {
      path: "selfService/stepFive/components/studentInfo",
      component: _3e2a6cc0,
      name: "index-selfService-stepFive-components-studentInfo"
    }, {
      path: "serviceSystem/evaluation/components/codeModal",
      component: _4de10958,
      name: "index-serviceSystem-evaluation-components-codeModal"
    }, {
      path: "serviceSystem/general-province/components/downloadPDF",
      component: _68c414f6,
      name: "index-serviceSystem-general-province-components-downloadPDF"
    }, {
      path: "serviceSystem/general-province/components/downloadPDFNew",
      component: _baaf43ea,
      name: "index-serviceSystem-general-province-components-downloadPDFNew"
    }, {
      path: "serviceSystem/general-province/components/leave-message",
      component: _217578ec,
      name: "index-serviceSystem-general-province-components-leave-message"
    }, {
      path: "serviceSystem/general-province/components/newPlan-by-lastStep",
      component: _56a3de8f,
      name: "index-serviceSystem-general-province-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystem/general-province/components/scheme-inspect",
      component: _ed5579fe,
      name: "index-serviceSystem-general-province-components-scheme-inspect"
    }, {
      path: "serviceSystem/general-province/components/studentInfo",
      component: _78397778,
      name: "index-serviceSystem-general-province-components-studentInfo"
    }, {
      path: "serviceSystem/general-province/components/visable-field-config",
      component: _def10b86,
      name: "index-serviceSystem-general-province-components-visable-field-config"
    }, {
      path: "serviceSystem/general-province/utils/utils",
      component: _a452d240,
      name: "index-serviceSystem-general-province-utils-utils"
    }, {
      path: "serviceSystem/new-version/components/design-thought",
      component: _cdf941ce,
      name: "index-serviceSystem-new-version-components-design-thought"
    }, {
      path: "serviceSystem/new-version/components/leave-message",
      component: _52e2fc9c,
      name: "index-serviceSystem-new-version-components-leave-message"
    }, {
      path: "serviceSystem/new-version/components/newPlan-by-lastStep",
      component: _30e8bad5,
      name: "index-serviceSystem-new-version-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystem/new-version/components/scheme-inspect",
      component: _775d52fb,
      name: "index-serviceSystem-new-version-components-scheme-inspect"
    }, {
      path: "serviceSystem/new-version/components/studentInfo",
      component: _f9d872ec,
      name: "index-serviceSystem-new-version-components-studentInfo"
    }, {
      path: "serviceSystem/new-version/components/visable-field-config",
      component: _0243b292,
      name: "index-serviceSystem-new-version-components-visable-field-config"
    }, {
      path: "serviceSystem/new-version/utils/utils",
      component: _b3985bb4,
      name: "index-serviceSystem-new-version-utils-utils"
    }, {
      path: "serviceSystem/newRegulation/downloadPDF/downloadPDF",
      component: _23c6a98c,
      name: "index-serviceSystem-newRegulation-downloadPDF-downloadPDF"
    }, {
      path: "serviceSystem/opportunities-plan/components/leave-message",
      component: _3342581c,
      name: "index-serviceSystem-opportunities-plan-components-leave-message"
    }, {
      path: "serviceSystem/opportunities-plan/components/scheme-preview",
      component: _817e5cf6,
      name: "index-serviceSystem-opportunities-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/opportunities-plan/components/studentInfo",
      component: _be83a118,
      name: "index-serviceSystem-opportunities-plan-components-studentInfo"
    }, {
      path: "serviceSystem/professionalGroup/components/chooseSpeciality",
      component: _3e1a3f88,
      name: "index-serviceSystem-professionalGroup-components-chooseSpeciality"
    }, {
      path: "serviceSystem/professionalGroup/components/fieldConfig",
      component: _6ae1cad0,
      name: "index-serviceSystem-professionalGroup-components-fieldConfig"
    }, {
      path: "serviceSystem/professionalGroup/components/newPlanByLastStep",
      component: _2f55e7b6,
      name: "index-serviceSystem-professionalGroup-components-newPlanByLastStep"
    }, {
      path: "serviceSystem/professionalGroup/components/preview",
      component: _9c110c88,
      name: "index-serviceSystem-professionalGroup-components-preview"
    }, {
      path: "serviceSystem/professionalGroup/utils/utils",
      component: _49c66519,
      name: "index-serviceSystem-professionalGroup-utils-utils"
    }, {
      path: "serviceSystem/professionNew/components/newPlanByLastStep",
      component: _fb79446c,
      name: "index-serviceSystem-professionNew-components-newPlanByLastStep"
    }, {
      path: "serviceSystem/professionNew/components/preview",
      component: _2cec8e60,
      name: "index-serviceSystem-professionNew-components-preview"
    }, {
      path: "serviceSystem/professionNew/utils/utils",
      component: _477a0fa6,
      name: "index-serviceSystem-professionNew-utils-utils"
    }, {
      path: "serviceSystem/serviceConditions/components/addConfig",
      component: _196397a2,
      name: "index-serviceSystem-serviceConditions-components-addConfig"
    }, {
      path: "serviceSystem/volunteer/component/distributeMoal",
      component: _097e93ca,
      name: "index-serviceSystem-volunteer-component-distributeMoal"
    }, {
      path: "serviceSystemArt/general-province/components/downloadPDF",
      component: _79418706,
      name: "index-serviceSystemArt-general-province-components-downloadPDF"
    }, {
      path: "serviceSystemArt/general-province/components/leave-message",
      component: _170aa3a6,
      name: "index-serviceSystemArt-general-province-components-leave-message"
    }, {
      path: "serviceSystemArt/general-province/components/newPlan-by-lastStep",
      component: _2aa25f10,
      name: "index-serviceSystemArt-general-province-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystemArt/general-province/components/scheme-inspect",
      component: _16f6b5e0,
      name: "index-serviceSystemArt-general-province-components-scheme-inspect"
    }, {
      path: "serviceSystemArt/general-province/components/studentInfo",
      component: _7186d5c5,
      name: "index-serviceSystemArt-general-province-components-studentInfo"
    }, {
      path: "serviceSystemArt/general-province/components/visable-field-config",
      component: _3c5909dc,
      name: "index-serviceSystemArt-general-province-components-visable-field-config"
    }, {
      path: "serviceSystemArt/general-province/utils/utils",
      component: _092fa1e1,
      name: "index-serviceSystemArt-general-province-utils-utils"
    }, {
      path: "serviceSystemArt/new-regulation/components/SmartReport",
      component: _680e2312,
      name: "index-serviceSystemArt-new-regulation-components-SmartReport"
    }, {
      path: "serviceSystemArt/new-regulation/downloadPDF/downloadPDF",
      component: _3900873c,
      name: "index-serviceSystemArt-new-regulation-downloadPDF-downloadPDF"
    }, {
      path: "serviceSystemArt/new-version/components/design-thought",
      component: _7ca1464c,
      name: "index-serviceSystemArt-new-version-components-design-thought"
    }, {
      path: "serviceSystemArt/new-version/components/leave-message",
      component: _4b7b47d1,
      name: "index-serviceSystemArt-new-version-components-leave-message"
    }, {
      path: "serviceSystemArt/new-version/components/newPlan-by-lastStep",
      component: _82eba498,
      name: "index-serviceSystemArt-new-version-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystemArt/new-version/components/scheme-inspect",
      component: _bfed5e88,
      name: "index-serviceSystemArt-new-version-components-scheme-inspect"
    }, {
      path: "serviceSystemArt/new-version/components/studentInfo",
      component: _76698869,
      name: "index-serviceSystemArt-new-version-components-studentInfo"
    }, {
      path: "serviceSystemArt/new-version/components/visable-field-config",
      component: _256b0fb8,
      name: "index-serviceSystemArt-new-version-components-visable-field-config"
    }, {
      path: "serviceSystemArt/new-version/utils/utils",
      component: _73ae2a85,
      name: "index-serviceSystemArt-new-version-utils-utils"
    }, {
      path: "serviceSystemArt/opportunities-plan/components/leave-message",
      component: _59cf411d,
      name: "index-serviceSystemArt-opportunities-plan-components-leave-message"
    }, {
      path: "serviceSystemArt/opportunities-plan/components/scheme-preview",
      component: _6a5108a4,
      name: "index-serviceSystemArt-opportunities-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/opportunities-plan/components/studentInfo",
      component: _73c364b5,
      name: "index-serviceSystemArt-opportunities-plan-components-studentInfo"
    }, {
      path: "stationNotification/myReceived/components/edit",
      component: _50a1b37c,
      name: "index-stationNotification-myReceived-components-edit"
    }, {
      path: "stationNotification/myReceived/components/readView",
      component: _7d00054d,
      name: "index-stationNotification-myReceived-components-readView"
    }, {
      path: "stationNotification/myRelease/components/edit",
      component: _73b51464,
      name: "index-stationNotification-myRelease-components-edit"
    }, {
      path: "IPADManage/agentManage/agentCardManage/components/soldRecords",
      component: _c86929d8,
      name: "index-IPADManage-agentManage-agentCardManage-components-soldRecords"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/customerDetail",
      component: _54788fc2,
      name: "index-IPADManage-agentManage-agentCustomer-components-customerDetail"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/orderList",
      component: _e51c642e,
      name: "index-IPADManage-agentManage-agentCustomer-components-orderList"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/province",
      component: _a6940b68,
      name: "index-IPADManage-agentManage-agentCustomer-components-province"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/viewInfo",
      component: _21d61db4,
      name: "index-IPADManage-agentManage-agentCustomer-components-viewInfo"
    }, {
      path: "IPADManage/agentManage/agentList/components/hairpin",
      component: _7680ded0,
      name: "index-IPADManage-agentManage-agentList-components-hairpin"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/card-list",
      component: _cf5f3b9c,
      name: "index-IPADManage-agentManage-agentProfit-components-card-list"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/dictConfig",
      component: _36e43c3e,
      name: "index-IPADManage-agentManage-agentProfit-components-dictConfig"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/orderDetail",
      component: _7c2fdc76,
      name: "index-IPADManage-agentManage-agentProfit-components-orderDetail"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/orderList",
      component: _1354a583,
      name: "index-IPADManage-agentManage-agentProfit-components-orderList"
    }, {
      path: "IPADManage/agentManage/agentProfit2/components/witchdraw",
      component: _75079bde,
      name: "index-IPADManage-agentManage-agentProfit2-components-witchdraw"
    }, {
      path: "IPADManage/agentManage/agentProfit2/components/witchdrawOrder",
      component: _dc941580,
      name: "index-IPADManage-agentManage-agentProfit2-components-witchdrawOrder"
    }, {
      path: "IPADManage/agentManage/cardUsageRecord/components/editTime",
      component: _7012b7c9,
      name: "index-IPADManage-agentManage-cardUsageRecord-components-editTime"
    }, {
      path: "IPADManage/agentManage/revenueBreakdownQuery/components/table-expand",
      component: _7b21d0e8,
      name: "index-IPADManage-agentManage-revenueBreakdownQuery-components-table-expand"
    }, {
      path: "IPADManage/agentManage/searchCard/components/cardView",
      component: _77e53a01,
      name: "index-IPADManage-agentManage-searchCard-components-cardView"
    }, {
      path: "IPADManage/agentManage/searchCard/components/convertCard",
      component: _219ff832,
      name: "index-IPADManage-agentManage-searchCard-components-convertCard"
    }, {
      path: "IPADManage/agentManage/searchCard/components/invalidCard",
      component: _3261542b,
      name: "index-IPADManage-agentManage-searchCard-components-invalidCard"
    }, {
      path: "noticeOnline/components/myReceived/components/edit",
      component: _4b8e22fe,
      name: "index-noticeOnline-components-myReceived-components-edit"
    }, {
      path: "noticeOnline/components/mySend/components/edit",
      component: _dca196b0,
      name: "index-noticeOnline-components-mySend-components-edit"
    }, {
      path: "noticeOnline/components/mySend/components/readView",
      component: _e85ddf0e,
      name: "index-noticeOnline-components-mySend-components-readView"
    }, {
      path: "serviceSystem/general-province/estimate-plan/components/choose-of-profession",
      component: _5b8b5620,
      name: "index-serviceSystem-general-province-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/estimate-plan/components/scheme-preview",
      component: _25f88a14,
      name: "index-serviceSystem-general-province-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/general-province/final-plan/components/choose-of-profession",
      component: _b2e845cc,
      name: "index-serviceSystem-general-province-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/final-plan/components/scheme-preview",
      component: _51140c84,
      name: "index-serviceSystem-general-province-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/general-province/initial-plan/components/choose-of-profession",
      component: _ab979fe8,
      name: "index-serviceSystem-general-province-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/initial-plan/components/scheme-preview",
      component: _ee682ba0,
      name: "index-serviceSystem-general-province-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/general-province/smart-report/components/choose-of-profession",
      component: _7b5b5ab2,
      name: "index-serviceSystem-general-province-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/smart-report/components/scheme-detail",
      component: _2b0f6cb3,
      name: "index-serviceSystem-general-province-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystem/new-version/estimate-plan/components/choose-of-profession",
      component: _9ff6b82c,
      name: "index-serviceSystem-new-version-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/estimate-plan/components/downloadPDF",
      component: _5450cb68,
      name: "index-serviceSystem-new-version-estimate-plan-components-downloadPDF"
    }, {
      path: "serviceSystem/new-version/estimate-plan/components/scheme-preview",
      component: _fcffc6e4,
      name: "index-serviceSystem-new-version-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/new-version/final-plan/components/choose-of-profession",
      component: _0c3a8060,
      name: "index-serviceSystem-new-version-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/final-plan/components/scheme-preview",
      component: _409a0984,
      name: "index-serviceSystem-new-version-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/new-version/initial-plan/components/choose-of-profession",
      component: _5ec719d2,
      name: "index-serviceSystem-new-version-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/initial-plan/components/scheme-preview",
      component: _392b2076,
      name: "index-serviceSystem-new-version-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/new-version/smart-report/components/choose-of-profession",
      component: _2fee4478,
      name: "index-serviceSystem-new-version-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/smart-report/components/scheme-detail",
      component: _332554a6,
      name: "index-serviceSystem-new-version-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystemArt/general-province/estimate-plan/components/choose-of-profession",
      component: _5beca24f,
      name: "index-serviceSystemArt-general-province-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/estimate-plan/components/scheme-preview",
      component: _7d67ea9a,
      name: "index-serviceSystemArt-general-province-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/general-province/final-plan/components/choose-of-profession",
      component: _20d0a41b,
      name: "index-serviceSystemArt-general-province-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/final-plan/components/scheme-preview",
      component: _0acf5502,
      name: "index-serviceSystemArt-general-province-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/general-province/initial-plan/components/choose-of-profession",
      component: _b3398a66,
      name: "index-serviceSystemArt-general-province-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/initial-plan/components/scheme-preview",
      component: _6cc659b1,
      name: "index-serviceSystemArt-general-province-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/general-province/smart-report/components/choose-of-profession",
      component: _778a6573,
      name: "index-serviceSystemArt-general-province-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/smart-report/components/scheme-detail",
      component: _6c388912,
      name: "index-serviceSystemArt-general-province-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan/components/choose-of-profession",
      component: _7f21372b,
      name: "index-serviceSystemArt-new-version-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan/components/downloadPDF",
      component: _fcadac2a,
      name: "index-serviceSystemArt-new-version-estimate-plan-components-downloadPDF"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan/components/scheme-preview",
      component: _3958748f,
      name: "index-serviceSystemArt-new-version-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/new-version/final-plan/components/choose-of-profession",
      component: _4d639cbf,
      name: "index-serviceSystemArt-new-version-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/final-plan/components/scheme-preview",
      component: _2728cdba,
      name: "index-serviceSystemArt-new-version-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/new-version/initial-plan/components/choose-of-profession",
      component: _0bcacb1e,
      name: "index-serviceSystemArt-new-version-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/initial-plan/components/scheme-preview",
      component: _36d74455,
      name: "index-serviceSystemArt-new-version-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/new-version/smart-report/components/choose-of-profession",
      component: _697c75d2,
      name: "index-serviceSystemArt-new-version-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/smart-report/components/scheme-detail",
      component: _96648c24,
      name: "index-serviceSystemArt-new-version-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/general-province/initial-plan",
      component: _639f84d4,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-general-province-initial-plan"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/general-province/scheme-preview",
      component: _14e732e2,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-general-province-scheme-preview"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-regulation/initial-plan",
      component: _669f24dc,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-regulation-initial-plan"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-regulation/PlanSelection",
      component: _7f053673,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-regulation-PlanSelection"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-regulation/RightDrawer",
      component: _36c83d3d,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-regulation-RightDrawer"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-version/initial-plan",
      component: _7d737e84,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-version-initial-plan"
    }, {
      path: "notice/components/stationNotification/myReceived/components/edit",
      component: _5bf4d75e,
      name: "index-notice-components-stationNotification-myReceived-components-edit"
    }, {
      path: "notice/components/stationNotification/myRelease/components/edit",
      component: _c546277c,
      name: "index-notice-components-stationNotification-myRelease-components-edit"
    }, {
      path: "notice/components/stationNotification/myRelease/components/readView",
      component: _14456b13,
      name: "index-notice-components-stationNotification-myRelease-components-readView"
    }]
  }, {
    path: "/policy",
    component: _44089fe8,
    name: "policy"
  }, {
    path: "/schemeCheck",
    component: _702fe352,
    name: "schemeCheck"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
